import { Component, SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Input, OnInit, HostListener, ElementRef } from '@angular/core';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { CrossTabOutputItem, PairWiseDetails } from 'src/app/common/models/crosstab.model';
import * as _ from 'lodash';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from '../../../../common/constants/common-constants';
import { AuthenticationService } from 'src/app/common/services/authentication.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { SnapshotService } from '../../Services/snapshot.service';
import { mapCalendarYearLabel } from 'src/app/common/pipes/time-period-label.pipe';


@Component({
  selector: 'app-table-output-snapshot',
  templateUrl: './table-output-snapshot.component.html',
  styleUrls: ['./table-output-snapshot.component.css']
})
export class TableOutputSnapshotComponent {
  @Input() isPairWise: boolean = false;
  @Input() DefaultConfidenceLevel: string | undefined = '95%';
  @Input() insufficientBase: string = '';
  @Input() LowBase: string = '';
  @Input() selectedIndex: string = '';
  @Input() isIndex: boolean = false;
  @Input() isSampleSizeBlock: boolean = false;
  @Input() isWeightedSampleBlock: boolean = false;
  @Input() selectedWeight: string = '';
  @Input() selectedDataFormat: string = '';
  @Input() weightedBaseInput: boolean = true;
  @Input() selectedweight:any;
  @Input() dropDownBaseSelectedName:string ='';
   @Input() metricHeader?: string;
  data :any = [];
  LowBaseSample = COMMON_CONSTANTS.LowBase_Sample;
  InsufficientBaseSample = COMMON_CONSTANTS.InsufficientBase_Sample;
  @Input() threshold: string = '';
  ThresholdValue: number = 0;
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;

  pairWiseVariables: string[] = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
  @Input() MainData: any = [];
  @Input() TrendToggleOn: boolean = false;
  @Input() isTranspose: boolean = false;
  cellWidth: number = 200;
  cellHeight: number = 30;
  crossTabReceivedData: any = [];
  dropdownLevel1 : any;
  dropdownLevel2 : any;
  staticTimePeriod: boolean = false;
  @Input() isTotalBase: boolean = false;
  @Input() TrendToggleContainer: boolean = true;
  @Input() isAnswerBase: boolean = false;
  @Input() isSampleSize: boolean = false;
  @Input() isWeightedLabel: boolean = false;
  @Input() isWeightedNumerator: boolean = false;
  @Input() isUnWeightedNumerator: boolean = false;
  @Input() DefaultSampleSize: string | undefined;
  @Input() snapshotdata: any;
  @Input() dropDownData : any;
  @Input() defaultShowSampleSize : String = "Single";
  @Input() snapshotType : any;
  @Input() isAudienceType : boolean = false;
  private _crossTabReceivedData: any;
  width: { [klass: string]: any } | null | undefined;
  constructor(
    private dataSharingService: CrosstabService,
    private _authenticateService: AuthenticationService,
    public breakpointObserver: BreakpointObserver,
    private elementRef: ElementRef,
    public _configService: SnapshotService
  ) {}

  ngOnInit() {
   this.data = _.cloneDeep(this.MainData);
    this.LowBaseSample = this.LowBase == "" ? 0 : Number(this.LowBase);
    this.InsufficientBaseSample = this.insufficientBase == "" ? 0 : Number(this.insufficientBase);
    this.ThresholdValue = this.threshold == "" ? 0 : Number(this.threshold);

    if(this.data && this.data.Column && !this.data.Column[0].Data[0].Child){
      this.data.Column[0].Data[0].Child = this.dropDownBaseSelectedName;
      this.data.Column[0].Data[0].ChildName = this.dropDownBaseSelectedName;
      this.staticTimePeriod = true;
    }else{
      this.staticTimePeriod = false;
    }

    //this.alignMentForMinWidth()
    this.getOutputData();
    if(!this.TrendToggleContainer){
       this.TrendToggleOn=true;
    }
  }

  getHeaderThirdColumnHeader(){
    const option = this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase();
    return option == "multiplemarkets" ? "Market" : option == "audiencesnapshot" ? "Audience" : "Brand";
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.data && changes['selectedweight']){
      if(this.data && this.data.Column && this.data.Column[0].Data[0].Child && this.data.Column[0].Data[0].Child == changes['selectedweight'].previousValue){
        this.data.Column[0].Data[0].Child = changes['selectedweight'].currentValue;
        this.data.Column[0].Data[0].ChildName = changes['selectedweight'].currentValue;
        this.staticTimePeriod = true;
      }else{
        this.staticTimePeriod = false;
      }
    }

      if(changes['TrendToggleOn']?.currentValue){
        this.data.Row = this.MainData.Row.filter((row:any) => row.Data[0].NestedArray[0].trend !== false);
      }
    else{
      this.data.Row = this.MainData.Row;
    }


    if(this.snapshotType.toLowerCase() == "multiple" || (this.snapshotType.toLowerCase() == "audience" && this._configService.multiCohort)){
      this.dropdownLevel1 = this.dropDownData.dropDownLevel1;
      this.dropdownLevel2 = this.dropDownData.dropDownLevel2;
      this.data = _.cloneDeep(this.MainData);

      if(this.data && this.data.Column && !this.data.Column[0].Data[0].Child){
        this.data.Column[0].Data[0].Child = this.dropDownBaseSelectedName;
        this.data.Column[0].Data[0].ChildName = this.dropDownBaseSelectedName;
        this.staticTimePeriod = true;
      }else{
        this.staticTimePeriod = false;
      }

      if(this.snapshotType.toLowerCase() == "audience" && this._configService.multiCohort){
        // Audience mode: filter by cohort group or metric
        if(this.dropdownLevel1 == 0){
          // Default - no filtering
        }
        else if(this.dropdownLevel1 == 1){
          // "All Audience for One Variable" - filter NestedArray by metric/variable name
          let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
          if(metric.length > 0){
            this.data.Row.map((item:any)=>{
              if(item.Data.length>0 && item.Data[0].NestedArray.length>0){
                item.Data[0].NestedArray = item.Data[0].NestedArray.filter((d:any)=>d.Child.toLowerCase() == metric[0].name.toLowerCase())
              }
            })

            this.data.Row = this.data.Row.filter((item:any)=>{
              if(item.Data.length>0){
                if( item.Data[0].NestedArray.length>0){
                  return true;
                }
              }
              return false;
            })
          }
          this.dropdownLevel1 = 0;
        }else{
          // "All Variable for One Audience" - filter Rows by audience value (e.g., "Male")
          let selectedAudience = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
          if(selectedAudience.length > 0){
            this.data.Row = this.data.Row.filter((item:any)=>{
              if(item.Parent){
                return item.Parent.split('|').pop()?.toLowerCase() == selectedAudience[0].name.toLowerCase();
              }
              return true;
            });
          }
          this.dropdownLevel1 = 0;
        }
      }
      else{
        // Multiple brand/market mode
        if(this.dropdownLevel1 == 0){

      }
      else if(this.dropdownLevel1 == 1){
        let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
        this.data.Row.map((item:any)=>{
          if(item.Data.length>0 && item.Data[0].NestedArray.length>0){
            item.Data[0].NestedArray = item.Data[0].NestedArray.filter((d:any)=>d.brand.toLowerCase() == brand[0].name.toLowerCase())
          }
        })

        this.data.Row = this.data.Row.filter((item:any)=>{
          if(item.Data.length>0){
            if( item.Data[0].NestedArray.length>0){
              return true;
            }
          }
          return false;
        })
        // this.data.Row = this.data.Row.filter((item:any)=>{
        //   let flag = false;
        //   if(item.Data.length>0){
        //     if( item.Data[0].NestedArray.length>0){
        //       item.Data[0].NestedArray.map((d:any)=>{
        //         if(d.brand.toLowerCase() == brand[0].name.toLowerCase()){
        //           flag = true;
        //         }
        //       })
        //     }
        //   }

        //   return flag;
        // })



      }else{
        let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);

        this.data.Row.map((item:any)=>{
          if(item.Data.length>0 && item.Data[0].NestedArray.length>0){
            item.Data[0].NestedArray = item.Data[0].NestedArray.filter((d:any)=>d.Child.toLowerCase() == metric[0].name.toLowerCase())
          }
        })

        this.data.Row = this.data.Row.filter((item:any)=>{
          if(item.Data.length>0){
            if( item.Data[0].NestedArray.length>0){
              return true;
            }
          }

          return false;
        })
        // this.data.Row = this.data.Row.filter((item:any)=>{
        //   let flag = false;
        //   if(item.Data.length>0){
        //     if( item.Data[0].NestedArray.length>0){
        //       item.Data[0].NestedArray.map((d:any)=>{
        //         if(d.Child.toLowerCase() == metric[0].name.toLowerCase()){
        //           flag = true;
        //         }
        //       })
        //     }
        //   }

        //   return flag;
        // })
      }
      } // end multiple brand/market mode
    }
}
  // alignMentForMinWidth() {
  //   //const minWidth = 1500;
  //   // if (window.innerWidth >= minWidth)
  //   //   this.cellHeight = 60;
  //   // this.breakpointObserver
  //   //   .observe(['(min-width: 1500px)'])
  //   //   .subscribe((state: BreakpointState) => {
  //       // if (state.matches) {
  //       //   let height = 45;
  //       //   let setHeight = 60;
  //       //   this.SetHeight(height, setHeight)
  //       // } else {
  //       //   let height = 60;
  //       //   let setHeight = 45;
  //       //   this.SetHeight(height, setHeight)
  //       // }
  //    // });
  // }
  // SetHeight(height: number, setHeight: number) {
  //   const rowHeaders = this.elementRef.nativeElement.querySelectorAll('.preview-row-header-text');
  //   if (rowHeaders) {
  //     rowHeaders.forEach((rowHeader: HTMLElement) => {
  //       const Height = rowHeader.offsetHeight; // Or use clientWidth for width without padding
  //       if (Height == height)
  //         rowHeader.style.height = setHeight + 'px';
  //     });
  //   }
  // }
  //@HostListener('document:click', ['$event'])
  //onDocumentClick(event: Event): void {
  //  //Check if the click event occurred outside the <div> block.
  //  document.addEventListener('mousemove', () => this._authenticateService.resetSessionTimeoutTimer());
  //  document.addEventListener('keydown', () => this._authenticateService.resetSessionTimeoutTimer());
  //}
  getOutputData() {
    this.crossTabReceivedData = this.snapshotdata;
        if (typeof window !== 'undefined') {
      (window as any)['CrossTabData'] = _.cloneDeep(this.snapshotdata);
    }
    // this.dataSharingService.crossTabOuputDataSubject$.subscribe(({ data }) => {
    //
    //   this.crossTabReceivedData = data;

    //   if (typeof window !== 'undefined') {
    //     (window as any)['CrossTabData'] = _.cloneDeep(data);
    //   }
    // });
  }

  onUserAction() {
    this.getOutputData();
  }

  getHeader(item: any) {
    if (item) {
      let splitedText = item.split('|');
      return mapCalendarYearLabel(splitedText.join(' : '));
    }
    return item;
  }
  getMetricHeader(): string {
    if (this.metricHeader) {
      return this.metricHeader;
    }
  
    // Return 'Variable' for audience snapshot regardless of multiCohort
    if (this.isAudienceType || this.snapshotType === 'audience') {
      return 'Variable';
    }
    return 'Metric';
  }

  getWidgetHeaderWithBrand(): string {
    return 'Widget';
  }
  getWidgetNameWithBrand(rowItem: any): string {
  const widgetName = this.getHeader(rowItem.Child);
  if (!widgetName) return '';

  // Only for Audience snapshot
  if (!this.isAudienceType) {
    return widgetName;
  }

  const brandLabel = this.getSelectedBrandLabel();
  if (!brandLabel) {
    return widgetName;
  }

  const widgets = this._configService.widgetData;
  if (!Array.isArray(widgets)) {
    return widgetName;
  }

  // find matching widget and check its audience
  for (let i = 0; i < widgets.length; i++) {
    const widget = widgets[i];

    if (widget?.widget_name === widgetName) {
      if (widget.audience == null) {
        return `${widgetName} ${brandLabel}`;
      }
      break; // matched widget found, stop looping
    }
  }

  return widgetName;
}


  getSelectedBrandLabel(): string {
    // Only for audience snapshots
    if (!this.isAudienceType || !this._configService.multiCohort) {
      return '';
    }

    const value =
      this._configService?.finalLeftPanelSubmitObject?.previewData
        ?.Audiencebrand?.[0]?.option;

    if (!value) {
      return '';
    }
    
    const rawBrandName = value.split('|').pop() ?? value;
    const brandName = `(${rawBrandName})`;
    return brandName;
  }

  //To get the count of number of rows along with nesting
  getrowCount() {
    let rowCount = 0;
    if (
      this.data != null &&
      this.data != undefined &&
      this.data['Row'] != undefined
    ) {
      this.data.Row.forEach((x: any) => {
        rowCount = rowCount + x.Data.length;
      });
      if (this.data['RowNesting'] != undefined) {
        this.data.RowNesting.forEach((x: any) => {
          rowCount = rowCount * x.Data.length;
        });
      }
    }
    return rowCount;
  }
  // to get width of the cell based on the
  //getWidthofCellOnCount(panel: string, panelNested: string) {
  //  let rowCellCount = 1;
  //  let count = 0;
  //  if (this.data != null && this.data != undefined && this.data[panel] != undefined) {
  //    if (this.data[panelNested] != undefined) {

  //      for (let i = 0; i < this.data[panelNested].length; i++) {

  //        for (let j = 0; j < this.data[panelNested][i].Data.length; j++) {
  //          count = this.data[panelNested][i].Data[j].NestedArray.length;
  //          if (count > 0) {
  //            rowCellCount = rowCellCount * count;
  //          }
  //        }
  //        if (count == 0) {
  //          rowCellCount = rowCellCount * this.data[panelNested][i].Data.length;
  //        }
  //      }

  //    }

  //  }
  //  let heightWidth = (panel == 'Row') ? this.cellHeight : this.cellWidth;
  //  return rowCellCount * heightWidth;
  //}

  getWidthofCellOnCount(panel: string, panelNested: string): number {
    let rowCellCount = 1;
    let count = 1;
    if (this.data && this.data[panel]) {
      const nestedData = this.data[panelNested];

      if (nestedData) {
        nestedData.forEach((nestedItem: any) => {
          rowCellCount *= nestedItem.Data.length;
          nestedItem.Data.forEach((nestedArrayData: any) => {
            if (nestedArrayData.NestedArray.length > 0) {
              rowCellCount *= nestedArrayData.NestedArray.length;
            }
          });

          //if (nestedItem.NestedArray && nestedItem.NestedArray.length > 0) {
          //  nestedItem.NestedArray.forEach((innerItem: any) => {
          //    count *= innerItem.length;
          //  });
          //} else {
          //  rowCellCount *= nestedItem.Data.length;
          //}
        });
      }
    }

    const heightWidth = panel === 'Row' ? this.cellHeight : this.cellWidth;
    return rowCellCount * heightWidth;
  }

  getWidthofCellOnCount_Row(
    panel: string,
    panelNested: string,
    rowData: any
  ): number {
    let rowCellCount = 1;

    if (rowData.NestedArray.length > 0) {
      rowData.NestedArray.forEach((nestedItem: any) => {
        //rowCellCount *= nestedItem.NestedArray.length;

        if (nestedItem.NestedArray.length > 0) {
          rowCellCount *= nestedItem.NestedArray.length;
        } else {
          rowCellCount = rowData.NestedArray.length;
        }

        //nestedItem.NestedArray.forEach((nestedItemlvl2: any) => {
        //  rowCellCount *= nestedItemlvl2.length;
        //});
      });
    }

    // rowCellCount = rowData.NestedArray.length;

    const heightWidth = panel === 'Row' ? this.cellHeight : this.cellWidth;
    return rowCellCount * heightWidth;
  }


  getWidthofCellOnCount_RowMultiple(
    panel: string,
    panelNested: string,
    rowData: any
  ): number {
    let rowCellCount = 1;

    if(this.dropdownLevel1 == 0){
      rowCellCount = 1;
    }
    else{
      if(rowData.NestedArray.length > 0) {
        rowData.NestedArray.forEach((nestedItem: any) => {
        //rowCellCount *= nestedItem.NestedArray.length;

          if (nestedItem.NestedArray.length > 0) {
            rowCellCount *= nestedItem.NestedArray.length;
          } else {
            rowCellCount = rowData.NestedArray.length;
          }

        //nestedItem.NestedArray.forEach((nestedItemlvl2: any) => {
        //  rowCellCount *= nestedItemlvl2.length;
        //});
        });
      }
    }

    // rowCellCount = rowData.NestedArray.length;

    const heightWidth = panel === 'Row' ? this.cellHeight : this.cellWidth;
    return rowCellCount * heightWidth;
  }

  getWidthofCellOnCount_RowForMultiple(
    panel: string,
    panelNested: string,
    rowData: any,
    rowNestingData:any
  ): number {
    let rowCellCount = 1;

    if(this.dropdownLevel1 == 0){
      if(rowNestingData.NestedArray.length > 0){
        let totalCount = _.uniqBy(rowNestingData.NestedArray, (d:any) => d.brand);
        rowCellCount *=totalCount.length
      }
    }
    else if(this.dropdownLevel1 == 2){
      if (rowNestingData.NestedArray.length > 0) {
        let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
        let totalCount = _.uniqBy(_.filter(rowNestingData.NestedArray, x => x.Child.toLowerCase() == metric[0].name.toLowerCase()), x=> x.brand);
        // rowData.NestedArray.fo((nestedItem: any) => {
        //   //rowCellCount *= nestedItem.NestedArray.length;

        //   if (nestedItem.NestedArray.length > 0) {
        //     rowCellCount *= nestedItem.NestedArray.length;
        //   } else {
        //     rowCellCount = rowData.NestedArray.length;
        //   }

          //nestedItem.NestedArray.forEach((nestedItemlvl2: any) => {
          //  rowCellCount *= nestedItemlvl2.length;
          //});
        // });

        rowCellCount *=totalCount.length;
      }
    }
    else{
      if (rowData.NestedArray.length > 0) {
        rowData.NestedArray.forEach((nestedItem: any) => {
          //rowCellCount *= nestedItem.NestedArray.length;

          if (nestedItem.NestedArray.length > 0) {
            rowCellCount *= nestedItem.NestedArray.length;
          } else {
            rowCellCount = rowData.NestedArray.length;
          }

          //nestedItem.NestedArray.forEach((nestedItemlvl2: any) => {
          //  rowCellCount *= nestedItemlvl2.length;
          //});
        });
      }
    }

    // rowCellCount = rowData.NestedArray.length;

    const heightWidth = panel === 'Row' ? this.cellHeight : this.cellWidth;
    return rowCellCount * heightWidth;
  }

  getWidthofCellOnCount_Column(
    panel: string,
    panelNested: string,
    rowData: any
  ): number {
    let rowCellCount = 0;
    // let clonedArray = this.snapshotType != "multiple" ? this.getDistinctNestedItems(rowData.NestedArray) : (this.dropdownLevel1 == 1 ? this.getDistinctNestedItems(rowData.NestedArray,"multiple", "metric") : this.getDistinctNestedItems(rowData.NestedArray,"multiple","brand"));
    let clonedArray = this.getDistinctNestedItems(rowData.NestedArray);
    if (rowData.NestedArray.length > 0) {
      clonedArray.forEach((nestedItem: any) => {
        if (nestedItem.NestedArray.length > 0) {
          rowCellCount += nestedItem.NestedArray.length;
        } else {
          rowCellCount = clonedArray.length;
        }
      });
    } else {
      rowCellCount = 1;
    }
    const heightWidth = panel === 'Row' ? this.cellHeight : this.cellWidth;
    return rowCellCount * heightWidth;
  }

  getWidthofCellOnCount_ColumnForMultiple(
    panel: string,
    panelNested: string,
    rowData: any
  ): number {
    let rowCellCount = 0;
    if(this.dropdownLevel1 == 0 ){
      rowCellCount = this.getNestedItemsForMultiple(rowData.NestedArray);
    }else{
      let clonedArray = this.dropdownLevel1 == 1 ? this.getDistinctNestedItemsForWidth( rowData.NestedArray,"multiple", "metric") : this.getDistinctNestedItems(rowData.NestedArray,"multiple","brand");
      if (rowData.NestedArray.length > 0) {
        clonedArray.forEach((nestedItem: any) => {
          if (nestedItem.NestedArray.length > 0) {
            rowCellCount += nestedItem.NestedArray.length;
          } else {
            rowCellCount = clonedArray.length;
          }
        });
      } else {
        rowCellCount = 1;
      }
    }

    const heightWidth = panel === 'Row' ? this.cellHeight : this.cellWidth;
    return rowCellCount * heightWidth;
  }

  getNestingCount(index: number, panel: string, panelNested: string) {
    let rowCellCount = 1;

    if (
      this.data != null &&
      this.data != undefined &&
      this.data[panel] != undefined
    ) {
      if (this.data[panelNested] != undefined) {
        for (let i = 0; i <= index; i++) {
          rowCellCount = rowCellCount * this.data[panelNested][i].Data.length;
        }
      }
    }
    return this.getWidthofCellOnCount(panel, panelNested) / rowCellCount;
  }

  getRowNestingCount(index: number, panel: string, panelNested: string) {
    let rowCellCount = 1;

    if (
      this.data != null &&
      this.data != undefined &&
      this.data[panel] != undefined
    ) {
      if (this.data[panelNested] != undefined) {
        for (let i = 0; i <= index; i++) {
          rowCellCount = rowCellCount * this.data[panelNested][i].Data.length;
        }
      }
    }
    return this.getWidthofCellOnCount(panel, panelNested) / rowCellCount;
  }
  //get the column and column nested count
  getrowCellCount() {
    let rowCellCount = 0;
    if (
      this.data != null &&
      this.data != undefined &&
      this.data['Column'] != undefined
    ) {
      this.data.Column.forEach((x: any) => {
        rowCellCount = rowCellCount + x.Data.length;
      });
      if (this.data['ColNesting'] != undefined) {
        this.data.ColNesting.forEach((x: any) => {
          rowCellCount = rowCellCount * x.Data.length;
        });
      }
    }
    return rowCellCount;
  }

  //get the count for row or column nesting count
  getNestedLevelCount(index: number, nesting: any) {
    let count = 1;
    for (let i = 0; i < index; i++) {
      count = count * nesting[i].Data.length;
    }
    return count;
  }

  // Margin for the scroll based on the count of nested rows and columns
  getMarginForScroll() {
    let colRowCount = 0;
    let RowColCount = 0;

    if (this.data != null && this.data != undefined) {
      if (this.data['Column'] != undefined && this.data['Column'].length > 0)
        colRowCount = 1;
      if (
        this.data['Column'] != undefined &&
        this.data['Column'].length > 0 &&
        this.data['Column'][0]['Data'][0]['NestedArray'].length > 0
      )
        colRowCount = 2;
      if (
        this.data['Column'] != undefined &&
        this.data['Column'].length > 0 &&
        this.data['Column'][0]['Data'][0]['NestedArray'].length > 0 &&
        this.data['Column'][0]['Data'][0]['NestedArray'][0]['NestedArray']
          .length > 0
      )
        colRowCount = 3;
      if (this.data['Row'] != undefined && this.data['Row'].length > 0)
        RowColCount = 1;
      if (
        this.data['Row'] != undefined &&
        this.data['Row'].length > 0 &&
        this.data['Row'][0]['Data'][0]['NestedArray'].length > 0
      )
        RowColCount = 2;
      if (
        this.data['Row'] != undefined &&
        this.data['Row'].length > 0 &&
        this.data['Row'][0]['Data'][0]['NestedArray'].length > 0 &&
        this.data['Row'][0]['Data'][0]['NestedArray'][0]['NestedArray'].length >
        0
      )
        RowColCount = 3;
    }
    return `${45 * colRowCount}px 0 0 ${200 * RowColCount}px`;
  }

  getPercentage(rowItemData: any, colItemData: any) {

    let rowItem = rowItemData;
    let colItem = colItemData;
    (window as any)['CrossTabData_Index'] = [];
    if (this.isTranspose) {
      rowItem = { ...colItemData };
      colItem = { ...rowItemData };
    }

    // Find the row that matches the response codes
    const matchingRow = this.crossTabReceivedData.find(
      (row: CrossTabOutputItem) => {
        if (rowItem.isDerived && rowItem.CalculationType.toLowerCase() == 'mean' && this.selectedDataFormat == 'Respondent Level') {

          return (
            row.colResponseCode == colItem.responsecode &&
            row.rowVariableCode == rowItem.variablecode &&
            row.colVariableCode == colItem.variablecode &&
            row.colChild == colItem.Child &&
            row.CalculationType.toLowerCase() == 'mean'
          )
        }
        else if (rowItem.isDerived && rowItem.CalculationType.toLowerCase() == 'mean' && this.selectedDataFormat != 'Respondent Level') {
          return (
            row.colResponseCode == colItem.responsecode &&
            row.rowVariableCode == rowItem.variablecode &&
            row.colVariableCode == colItem.variablecode &&
            row.colChild == colItem.Child &&
            row.CalculationType.toLowerCase() == 'mean'
            && row.rowResponseCode === rowItem.responsecode
          )
        }
        else if (row.isCustomGroup) {
          return (
            row.rowResponseCode == rowItem.responsecode &&
            row.colResponseCode == colItem.responsecode &&
            row.rowVariableCode == rowItem.variablecode &&
            row.colVariableCode == colItem.variablecode &&
            row.colChild == colItem.Child &&
            (row.customGroupId == rowItem.customGroupId ||
              row.customGroupId == colItem.customGroupId)
          );
        } else if (row.isCustomCalculation) {
          return (
            row.rowResponseCode == rowItem.responsecode &&
            row.colResponseCode == colItem.responsecode &&
            row.rowVariableCode == rowItem.variablecode &&
            row.colVariableCode == colItem.variablecode &&
            row.colChild == colItem.Child &&
            (row.customCalculationId == rowItem.customCalculationId ||
              row.customCalculationId == colItem.customCalculationId)
          );
        } else {
          return (
            row.rowResponseCode == rowItem.responsecode &&
            row.colResponseCode == colItem.responsecode &&
            row.rowVariableCode == rowItem.variablecode &&
            row.colVariableCode == colItem.variablecode &&
            row.colChild == colItem.Child
          );
        }
      });

    if (this.isIndex && this.selectedIndex != "") {
      const matchingReferenceRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) => {
          if (row.isDerived && row.CalculationType.toLowerCase() == 'mean') {
            return (
              (row.CalculationType.toLowerCase() == 'mean' &&
                row.rowVariableCode == rowItemData.variablecode &&
                row.colChild == this.selectedIndex)
            );
          } else {
            return (
              (
                row.rowResponseCode == rowItemData.responsecode &&
                row.rowVariableCode == rowItemData.variablecode &&
                row.colChild == this.selectedIndex)

            );
          }
        }
      );
      if (matchingReferenceRow != undefined) {
        const matchingRowCopy = { ...matchingRow };
        const matchingReferenceRowCopy = { ...matchingReferenceRow };

        if (this.selectedWeight == "Unweighted") {
          matchingRowCopy.totalUnweightedShare = isNaN(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? null : isFinite(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? (matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) : null;
          matchingRowCopy.answerUnweightedShare = isNaN(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? null : isFinite(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? (matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) : null;

          matchingRowCopy.totalUnweightedShare_Index = matchingRowCopy.totalUnweightedShare;
          matchingRowCopy.answerUnweightedShare_Index = matchingRowCopy.answerUnweightedShare;

        }
        else {
          matchingRowCopy.totalWeightedShare = isNaN(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? null : isFinite(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? (matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) : null;
          matchingRowCopy.answerWeightedShare = isNaN(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? null : isFinite(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? (matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) : null;

          matchingRowCopy.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare;
          matchingRowCopy.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare;
        }
        let calculatedPercentage: number;
        let ShareNumber = this.isTotalBase
          ? (this.selectedWeight == "Unweighted" ? matchingRowCopy.totalUnweightedShare_Index : matchingRowCopy.totalWeightedShare_Index)
          : (this.selectedWeight == "Unweighted" ? matchingRowCopy.answerUnweightedShare_Index : matchingRowCopy.answerWeightedShare_Index);

        if (ShareNumber == null) {
          matchingRowCopy.ColorCode = "black";
          return '0';
        }
        else {
          calculatedPercentage = ((matchingRowCopy.isDerived && this.isIndex && this.selectedIndex != ""))
            ? Number((ShareNumber * 100).toFixed(1)) : ((matchingRowCopy.isDerived && matchingRowCopy.CalculationType == 'mean') || matchingRowCopy.isCustomCalculation) ? Number(ShareNumber.toFixed(1))
              : Number((ShareNumber * 100).toFixed(1));

          if (calculatedPercentage < (100 - this.ThresholdValue)) {
            matchingRowCopy.ColorCode = "red";
          }
          else if (calculatedPercentage > (100 + this.ThresholdValue)) {
            matchingRowCopy.ColorCode = "green";
          }
          else {
            matchingRowCopy.ColorCode = "black";
          }
        }
        this.crossTabReceivedData.forEach((row: any) => {
          if (
            row.CalculationType === matchingRowCopy.CalculationType &&
            row.Level1ColChild === matchingRowCopy.Level1ColChild &&
            row.Level1ColResponseCode === matchingRowCopy.Level1ColResponseCode &&
            row.Level1NestColVariableCode === matchingRowCopy.Level1NestColVariableCode &&
            row.Level1NestRowVariableCode === matchingRowCopy.Level1NestRowVariableCode &&
            row.Level1RowChild === matchingRowCopy.Level1RowChild &&
            row.Level1RowResponseCode === matchingRowCopy.Level1RowResponseCode &&
            row.Level2ColChild === matchingRowCopy.Level2ColChild &&
            row.Level2ColResponseCode === matchingRowCopy.Level2ColResponseCode &&
            row.Level2NestColVariableCode === matchingRowCopy.Level2NestColVariableCode &&
            row.Level2NestRowVariableCode === matchingRowCopy.Level2NestRowVariableCode &&
            row.Level2RowChild === matchingRowCopy.Level2RowChild &&
            row.Level2RowResponseCode === matchingRowCopy.Level2RowResponseCode &&
            row.colChild === matchingRowCopy.colChild &&
            row.colResponseCode === matchingRowCopy.colResponseCode &&
            row.colVariableCode === matchingRowCopy.colVariableCode &&
            row.rowChild === matchingRowCopy.rowChild &&
            row.rowResponseCode === matchingRowCopy.rowResponseCode &&
            row.rowVariableCode === matchingRowCopy.rowVariableCode
          ) {
            row.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare_Index;
            row.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare_Index;
            row.ColorCode = matchingRowCopy.ColorCode;
          }
        });

        if (typeof window !== 'undefined') {
          (window as any)['CrossTabData_Index'] = _.cloneDeep(this.crossTabReceivedData);
        }

        return this.calculatePercentage(matchingRowCopy);
      }
    }


    return this.calculatePercentage(matchingRow);
  }

  private calculatePercentage(
    matchingRow: CrossTabOutputItem
  ): number | string {


    if (this.selectedDataFormat != 'Respondent Level') {
      //let result: number | string = '0';
      //result = `${matchingRow.value}`;
      //return result;
      let calculatedPercentage: number;
      let calcBase: number;
      let calcWeightedBase: number;
      if (matchingRow == undefined) {
        return '0';
      }
      let ShareNumber = matchingRow.value;
      let BaseValue = matchingRow.value;
      let WeightedBaseValue = matchingRow.value;

      if (matchingRow) {
        calcBase = BaseValue == null ? 0 : Math.round(BaseValue);
        calcWeightedBase =
          WeightedBaseValue == null ? 0 : Math.round(WeightedBaseValue);
        if (this.isSampleSize) {
          return calcBase !== 0 ? calcBase : 'NA';
        } else if (this.isWeightedLabel) {
          return calcWeightedBase !== 0 ? calcWeightedBase : 'NA';
        }
        else {
          let result: number | string = '0';

          if (ShareNumber == null) {
            return '0';
          }
          calculatedPercentage = ((matchingRow.isDerived && matchingRow.CalculationType.toLowerCase() == 'mean') || (matchingRow.isCustomCalculation)) ? Number(ShareNumber.toFixed(1))
            : Number((ShareNumber * 100).toFixed(1));

          if (!this.isSampleSizeBlock) {
            if ((matchingRow.isDerived && matchingRow.CalculationType.toLowerCase() == "mean") || (matchingRow.isCustomCalculation)) {
              result = `${calculatedPercentage}`;
            }
            else {
              result = `${calculatedPercentage}%`;
            }
            return result;
          }
          else {
            if (calcBase !== 0) {
              if ((matchingRow.isDerived && matchingRow.CalculationType.toLowerCase() == "mean") || (matchingRow.isCustomCalculation)) {
                if (calcBase < this.InsufficientBaseSample) {
                  result = 'I/S';
                }
                else if (calcBase < this.LowBaseSample) {
                  result = `${calculatedPercentage} *`;
                }
                else {
                  result = `${calculatedPercentage}`;
                }
              }
              else {
                if (calcBase < this.InsufficientBaseSample) {
                  result = 'I/S';
                }
                else if (calcBase < this.LowBaseSample) {
                  result = `${calculatedPercentage}% *`;
                }
                else {
                  result = `${calculatedPercentage}% `;
                }
              }
              return result;
            }
            else {
              return '0';
            }

          }
        }
      }
    }
    else {

      let calculatedPercentage: number;
      let calcBase: number;
      let SigNumber: number | string;
      let changePy: number | string;
      let calcWeightedBase: number;
      let calcWeightedNumerator: number;
      let calcUnWeightedNumerator: number;
      if (matchingRow == undefined) {
        return '0';
      }

      let ShareNumber = (this.selectedDataFormat != 'Respondent Level' ? matchingRow.value : (this.isTotalBase
        ? (this.selectedWeight == "Unweighted" ? matchingRow.totalUnweightedShare : matchingRow.totalWeightedShare)
        : (this.selectedWeight == "Unweighted" ? matchingRow.answerUnweightedShare : matchingRow.answerWeightedShare)));
      let BaseValue = this.isTotalBase
        ? matchingRow.totalUnweightedBase
        : matchingRow.answerUnweightedBase;
      let WeightedBaseValue = this.isTotalBase
        ? (this.selectedWeight == "Unweighted" ? matchingRow.totalUnweightedBase : matchingRow.totalWeightedBase)
        : (this.selectedWeight == "Unweighted" ? matchingRow.answerUnweightedBase : matchingRow.answerWeightedBase);

      let numeratorValue = this.isTotalBase
        ? (matchingRow.totalWeightedNumerator) : (matchingRow.answerWeightedNumerator);


      let UnWeightednumeratorValue = (this.isTotalBase ? (matchingRow.CurrentNumeratorUnWeighted_Total) : matchingRow.CurrentNumeratorUnWeighted_Answer);

      this.Sig_LowerLimt =
        this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
          ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
              : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
      this.Sig_UpperLimt =
        this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
          ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
          : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
              : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
      let SignificanceValue = this.isTotalBase
        ? matchingRow.Significance_Total
        : matchingRow.Significance_Answer;
      let changevsPY = this.isTotalBase
        ? matchingRow.changeVsPY_Total
        : matchingRow.changeVsPY_Answer;

      // if (ShareNumber == null || BaseValue == null) {
      //   return '0';
      // }
      // if (ShareNumber == null || WeightedBaseValue == null) {
      //   return '0';
      // }
      if (matchingRow) {
        calcBase = BaseValue == null ? 0 : Math.round(BaseValue);
        calcWeightedBase =
          WeightedBaseValue == null ? 0 : Math.round(WeightedBaseValue);
        calcWeightedNumerator =
          numeratorValue == null ? 0 : Math.round(numeratorValue);
        calcUnWeightedNumerator =
          UnWeightednumeratorValue == null ? 0 : Math.round(UnWeightednumeratorValue);
        if (this.isSampleSize) {
          return calcBase !== 0 ? calcBase : 'NA';
        } else if (this.isWeightedLabel) {
          return calcWeightedBase !== 0 ? calcWeightedBase : 'NA';
        }
        else if (this.isWeightedNumerator) {
          return calcWeightedNumerator !== 0 ? calcWeightedNumerator : 'NA';
        }
        else if (this.isUnWeightedNumerator) {
          return calcUnWeightedNumerator !== 0 ? calcUnWeightedNumerator : 'NA';
        }
        else {
          let result: number | string = '0';

          if (ShareNumber == null) {
            return '0';
          }
          calculatedPercentage = (matchingRow.isDerived && this.isIndex && this.selectedIndex != "")
            ? Number((ShareNumber * 100).toFixed(1)) : ((matchingRow.isDerived && matchingRow.CalculationType.toLowerCase() == 'mean') || ((matchingRow.isCustomCalculation))) ? Number(ShareNumber.toFixed(1))
              : Number((ShareNumber * 100).toFixed(1));


          if (calcBase !== 0) {
            if (calcBase < this.InsufficientBaseSample) {
              result = 'I/S';
            }
            else {
              SigNumber =
                SignificanceValue == null || isNaN(SignificanceValue)
                  ? 0
                  : Number(SignificanceValue.toFixed(1));
              //changePy =
              //  changevsPY == null
              //    ? '0'
              //    : matchingRow.isDerived
              //      ? Number(changevsPY.toFixed(1))
              //      : Number((changevsPY * 100).toFixed(1));

              changePy =
                changevsPY == null
                  ? '0'
                  : ((matchingRow.isDerived &&
                    matchingRow.CalculationType.toLowerCase() == 'mean') ||
                    matchingRow.isCustomCalculation)
                    ? Number(changevsPY.toFixed(1))
                    : this.customRound(changevsPY * 100);

              if ((matchingRow.isDerived && matchingRow.CalculationType.toLowerCase() == "mean") || (matchingRow.isCustomCalculation)) {
                if (this.DefaultSampleSize == 'None') {
                  if (calcBase < this.LowBaseSample) {

                    if (this.isIndex && this.selectedIndex != "") {
                      if (calculatedPercentage < (100 - this.ThresholdValue)) {
                        result = `<span class="sigLower"> ${calculatedPercentage} *</span>`;
                      }
                      else if (calculatedPercentage > (100 + this.ThresholdValue)) {
                        result = `<span class="sigHigher"> ${calculatedPercentage} *</span>`;
                      }
                      else {
                        result = `${calculatedPercentage}`;
                      }
                    }
                    else {
                      result = `${calculatedPercentage} *`;
                    }
                  }
                  else {
                    if (this.isIndex && this.selectedIndex != "") {
                      if (calculatedPercentage < (100 - this.ThresholdValue)) {
                        result = `<span class="sigLower"> ${calculatedPercentage} </span>`;
                      }
                      else if (calculatedPercentage > (100 + this.ThresholdValue)) {
                        result = `<span class="sigHigher"> ${calculatedPercentage} </span>`;
                      }
                      else {
                        result = `${calculatedPercentage}`;
                      }
                    }
                    else {
                      result = `${calculatedPercentage}`;
                    }
                  }
                }
                else if (this.DefaultSampleSize == 'Pairwise') {
                  if (calcBase < this.LowBaseSample) {
                    result = `${calculatedPercentage} *`;
                  }
                  else {
                    result = `${calculatedPercentage}`;
                  }
                  let pairwiseText = this.pairWiseText(matchingRow.pairWiseValues);
                  if (pairwiseText != "") {
                    result = `${result} ${pairwiseText}`
                  }
                }
                else {
                  if (calcBase < this.LowBaseSample) {
                    if (changevsPY == null || changePy == "NA") {
                      result = `${calculatedPercentage} * | NA`;
                    }
                    else {
                      if (SigNumber < this.Sig_LowerLimt) {
                        result = `${calculatedPercentage} * |&nbsp; <span class="sigLower"> ${changePy} </span>`;
                      } else if (SigNumber > this.Sig_UpperLimt) {
                        result = `${calculatedPercentage} * |&nbsp; <span class="sigHigher"> ${changePy} </span>`;
                      } else {
                        result = `${calculatedPercentage} * |&nbsp; ${changePy}`;
                      }
                    }
                  }
                  else {
                    if (changevsPY == null || changePy == "NA") {
                      result = `${calculatedPercentage} | NA`;
                    }
                    else {
                      if (SigNumber < this.Sig_LowerLimt) {
                        result = `${calculatedPercentage} |&nbsp; <span class="sigLower"> ${changePy} </span>`;
                      } else if (SigNumber > this.Sig_UpperLimt) {
                        result = `${calculatedPercentage} |&nbsp; <span class="sigHigher"> ${changePy} </span>`;
                      } else {
                        result = `${calculatedPercentage} |&nbsp; ${changePy}`;
                      }
                    }
                  }
                }
              }
              else {
                if (this.DefaultSampleSize == 'None') {
                  if (calcBase < this.LowBaseSample) {
                    if (this.isIndex && this.selectedIndex != "") {
                      if (calculatedPercentage < (100 - this.ThresholdValue)) {
                        result = `<span class="sigLower"> ${calculatedPercentage} *</span>`;
                      }
                      else if (calculatedPercentage > (100 + this.ThresholdValue)) {
                        result = `<span class="sigHigher"> ${calculatedPercentage} *</span>`;
                      }
                      else {
                        result = `${calculatedPercentage} *`;
                      }
                    }
                    else {
                      result = `${calculatedPercentage}% *`;
                    }
                  }
                  else {
                    if (this.isIndex && this.selectedIndex != "") {
                      if (calculatedPercentage < (100 - this.ThresholdValue)) {
                        result = `<span class="sigLower"> ${calculatedPercentage} </span>`;
                      }
                      else if (calculatedPercentage > (100 + this.ThresholdValue)) {
                        result = `<span class="sigHigher"> ${calculatedPercentage} </span>`;
                      }
                      else {
                        result = `${calculatedPercentage}`;
                      }
                    }
                    else {
                      result = `${calculatedPercentage}%`;
                    }
                  }
                }
                else if (this.DefaultSampleSize == 'Pairwise') {
                  if (calcBase < this.LowBaseSample) {
                    result = `${calculatedPercentage}% *`;
                  }
                  else {
                    result = `${calculatedPercentage}%`;
                  }
                  let pairwiseText = this.pairWiseText(matchingRow.pairWiseValues);
                  if (pairwiseText != "") {
                    result = `${result} ${pairwiseText}`
                  }
                }
                else {
                  if (calcBase < this.LowBaseSample) {
                    if (changevsPY == null || changePy == "NA") {
                      result = `${calculatedPercentage}% * | NA`;
                    }
                    else {
                      if (changevsPY == null || changePy == "NA") {
                        result = `${calculatedPercentage}% * |&nbsp; NA`;
                      }
                      else {
                        if (SigNumber < this.Sig_LowerLimt) {
                          result = `${calculatedPercentage}% * |&nbsp; <span class="sigLower"> ${changePy}% </span>`;
                        } else if (SigNumber > this.Sig_UpperLimt) {
                          result = `${calculatedPercentage}% * |&nbsp; <span class="sigHigher"> ${changePy}% </span>`;
                        } else {
                          result = `${calculatedPercentage}% * |&nbsp; ${changePy}%`;
                        }
                      }
                    }
                  }
                  else {
                    if (changevsPY == null || changePy == "NA") {
                      result = `${calculatedPercentage}% |&nbsp; NA`;
                    }
                    else {
                      if (SigNumber < this.Sig_LowerLimt) {
                        result = `${calculatedPercentage}% |&nbsp; <span class="sigLower"> ${changePy}% </span>`;
                      } else if (SigNumber > this.Sig_UpperLimt) {
                        result = `${calculatedPercentage}% |&nbsp; <span class="sigHigher"> ${changePy}% </span>`;
                      } else {
                        result = `${calculatedPercentage}% |&nbsp; ${changePy}%`;
                      }
                    }
                  }
                }

              }
            }
          }
          return result;
        }
      }
      if (ShareNumber == null) {
        return '0';
      }
    }
    return '0';

  }

  getPercentage_colNest(
    rowItem: any,
    colItem: any,
    colNestItem: any,
    colNestItemLevel2: any
  ): number | string {
    (window as any)['CrossTabData_Index'] = [];
    if (this.isTranspose) {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) => {
          if (row.isDerived) {
            return (
              row.CalculationType.toLowerCase() == 'mean' &&
              row.colResponseCode == rowItem.responsecode &&
              row.rowResponseCode == colItem.responsecode &&
              row.rowVariableCode == colItem.variablecode &&
              row.Level1RowResponseCode == colNestItem.responsecode &&
              row.Level1NestRowVariableCode == colNestItem.variablecode &&
              row.Level2RowResponseCode == colNestItemLevel2.responsecode &&
              row.Level2NestRowVariableCode == colNestItemLevel2.variablecode &&
              row.colChild == rowItem.Child
            );
          } else {
            return (
              row.colResponseCode == rowItem.responsecode &&
              row.rowResponseCode == colItem.responsecode &&
              row.rowVariableCode == colItem.variablecode &&
              row.Level1RowResponseCode == colNestItem.responsecode &&
              row.Level1NestRowVariableCode == colNestItem.variablecode &&
              row.Level2RowResponseCode == colNestItemLevel2.responsecode &&
              row.Level2NestRowVariableCode == colNestItemLevel2.variablecode &&
              row.colChild == rowItem.Child


            );
          }
        }
      );

      return this.calculatePercentage(matchingRow);
    } else {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) => {
          if (row.isDerived && row.CalculationType.toLowerCase() == 'mean') {
            return (
              row.CalculationType.toLowerCase() == 'mean' &&
              row.rowResponseCode == rowItem.responsecode &&
              row.rowVariableCode == rowItem.variablecode &&
              row.colResponseCode == colItem.responsecode &&
              row.colVariableCode == colItem.variablecode &&
              row.Level1ColResponseCode == colNestItem.responsecode &&
              row.Level1NestColVariableCode == colNestItem.variablecode &&
              row.Level2ColResponseCode == colNestItemLevel2.responsecode &&
              row.Level2NestColVariableCode == colNestItemLevel2.variablecode &&
              row.colChild == colItem.Child &&
              row.rowChild == rowItem.Child &&
              row.Level1ColChild == colNestItem.Child &&
              row.Level2ColChild == colNestItemLevel2.Child
            );
          } else if (row.isCustomGroup) {
            return (
              row.isCustomGroup == true &&
              row.rowResponseCode == rowItem.responsecode &&
              row.rowVariableCode == rowItem.variablecode &&
              row.colResponseCode == colItem.responsecode &&
              row.colVariableCode == colItem.variablecode &&
              row.Level1ColResponseCode == colNestItem.responsecode &&
              row.Level1NestColVariableCode == colNestItem.variablecode &&
              row.Level2ColResponseCode == colNestItemLevel2.responsecode &&
              row.Level2NestColVariableCode == colNestItemLevel2.variablecode &&
              row.colChild == colItem.Child &&
              (row.customGroupId == rowItem.customGroupId ||
                row.customGroupId == colItem.customGroupId) &&
              row.rowChild == rowItem.Child &&
              row.Level1ColChild == colNestItem.Child &&
              row.Level2ColChild == colNestItemLevel2.Child
            );
          } else if (row.isCustomCalculation) {
            return (
              row.isCustomCalculation == true &&
              row.rowResponseCode == rowItem.responsecode &&
              row.rowVariableCode == rowItem.variablecode &&
              row.colResponseCode == colItem.responsecode &&
              row.colVariableCode == colItem.variablecode &&
              row.Level1ColResponseCode == colNestItem.responsecode &&
              row.Level1NestColVariableCode == colNestItem.variablecode &&
              row.Level2ColResponseCode == colNestItemLevel2.responsecode &&
              row.Level2NestColVariableCode == colNestItemLevel2.variablecode &&
              row.colChild == colItem.Child &&
              (row.customCalculationId == rowItem.customCalculationId ||
                row.customCalculationId == colItem.customCalculationId) &&
              row.rowChild == rowItem.Child &&
              row.Level1ColChild == colNestItem.Child &&
              row.Level2ColChild == colNestItemLevel2.Child
            );
          } else {
            return (
              row.rowResponseCode == rowItem.responsecode &&
              row.rowVariableCode == rowItem.variablecode &&
              row.colResponseCode == colItem.responsecode &&
              row.colVariableCode == colItem.variablecode &&
              row.Level1ColResponseCode == colNestItem.responsecode &&
              row.Level1NestColVariableCode == colNestItem.variablecode &&
              row.Level2ColResponseCode == colNestItemLevel2.responsecode &&
              row.Level2NestColVariableCode == colNestItemLevel2.variablecode &&
              row.colChild == colItem.Child &&
              row.rowChild == rowItem.Child &&
              row.Level1ColChild == colNestItem.Child &&
              row.Level2ColChild == colNestItemLevel2.Child
            );
          }
        }
      );
      if (this.isIndex && this.selectedIndex != "") {

        const matchingReferenceRow = this.crossTabReceivedData.find(
          (row: CrossTabOutputItem) => {
            if (row.isDerived && row.CalculationType.toLowerCase() == 'mean') {
              return (
                colNestItemLevel2 == "" ?
                  (row.CalculationType.toLowerCase() == 'mean' &&
                    row.rowResponseCode == rowItem.responsecode &&
                    row.rowVariableCode == rowItem.variablecode &&
                    row.colResponseCode == colItem.responsecode &&
                    row.colVariableCode == colItem.variablecode &&
                    row.colChild == colItem.Child &&
                    row.Level1ColChild == this.selectedIndex) : (row.CalculationType.toLowerCase() == 'mean' &&
                      row.rowResponseCode == rowItem.responsecode &&
                      row.rowVariableCode == rowItem.variablecode &&
                      row.colResponseCode == colItem.responsecode &&
                      row.colVariableCode == colItem.variablecode &&
                      row.Level1ColResponseCode == colNestItem.responsecode &&
                      row.Level1NestColVariableCode == colNestItem.variablecode &&
                      row.colChild == colItem.Child &&
                      row.Level2ColChild == this.selectedIndex
                  )
              );
            } else {
              return (
                colNestItemLevel2 == ""
                  ?
                  (row.rowResponseCode == rowItem.responsecode &&
                    row.rowVariableCode == rowItem.variablecode &&
                    row.colResponseCode == colItem.responsecode &&
                    row.colVariableCode == colItem.variablecode &&
                    row.colChild == colItem.Child &&
                    row.Level1ColChild == this.selectedIndex) : (row.rowResponseCode == rowItem.responsecode &&
                      row.rowVariableCode == rowItem.variablecode &&
                      row.colResponseCode == colItem.responsecode &&
                      row.colVariableCode == colItem.variablecode &&
                      row.Level1ColResponseCode == colNestItem.responsecode &&
                      row.Level1NestColVariableCode == colNestItem.variablecode &&
                      row.colChild == colItem.Child && row.Level2ColChild == this.selectedIndex)

              );
            }
          }
        );
        if (matchingReferenceRow != undefined) {
          const matchingRowCopy = { ...matchingRow };
          const matchingReferenceRowCopy = { ...matchingReferenceRow };

          if (this.selectedWeight == "Unweighted") {
            matchingRowCopy.totalUnweightedShare = isNaN(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? null : isFinite(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? (matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) : null;
            matchingRowCopy.answerUnweightedShare = isNaN(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? null : isFinite(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? (matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) : null;

            matchingRowCopy.totalUnweightedShare_Index = matchingRowCopy.totalUnweightedShare;
            matchingRowCopy.answerUnweightedShare_Index = matchingRowCopy.answerUnweightedShare;


          }
          else {
            matchingRowCopy.totalWeightedShare = isNaN(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? null : isFinite(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? (matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) : null;
            matchingRowCopy.answerWeightedShare = isNaN(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? null : isFinite(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? (matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) : null;

            matchingRowCopy.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare;
            matchingRowCopy.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare;

          }

          let calculatedPercentage: number;
          let ShareNumber = this.isTotalBase
            ? (this.selectedWeight == "Unweighted" ? matchingRowCopy.totalUnweightedShare_Index : matchingRowCopy.totalWeightedShare_Index)
            : (this.selectedWeight == "Unweighted" ? matchingRowCopy.answerUnweightedShare_Index : matchingRowCopy.answerWeightedShare_Index);

          if (ShareNumber == null) {
            matchingRowCopy.ColorCode = "black";
            return '0';
          }
          else {
            calculatedPercentage = (matchingRowCopy.isDerived && this.isIndex && this.selectedIndex != "")
              ? Number((ShareNumber * 100).toFixed(1)) : ((matchingRowCopy.isDerived && matchingRowCopy.CalculationType == 'mean') || ((matchingRow.isCustomCalculation))) ? Number(ShareNumber.toFixed(1))
                : Number((ShareNumber * 100).toFixed(1));

            if (calculatedPercentage < (100 - this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "red";
            }
            else if (calculatedPercentage > (100 + this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "green";
            }
            else {
              matchingRowCopy.ColorCode = "black";
            }
          }
          this.crossTabReceivedData.forEach((row: any) => {
            if (
              row.CalculationType === matchingRowCopy.CalculationType &&
              row.Level1ColChild === matchingRowCopy.Level1ColChild &&
              row.Level1ColResponseCode === matchingRowCopy.Level1ColResponseCode &&
              row.Level1NestColVariableCode === matchingRowCopy.Level1NestColVariableCode &&
              row.Level1NestRowVariableCode === matchingRowCopy.Level1NestRowVariableCode &&
              row.Level1RowChild === matchingRowCopy.Level1RowChild &&
              row.Level1RowResponseCode === matchingRowCopy.Level1RowResponseCode &&
              row.Level2ColChild === matchingRowCopy.Level2ColChild &&
              row.Level2ColResponseCode === matchingRowCopy.Level2ColResponseCode &&
              row.Level2NestColVariableCode === matchingRowCopy.Level2NestColVariableCode &&
              row.Level2NestRowVariableCode === matchingRowCopy.Level2NestRowVariableCode &&
              row.Level2RowChild === matchingRowCopy.Level2RowChild &&
              row.Level2RowResponseCode === matchingRowCopy.Level2RowResponseCode &&
              row.colChild === matchingRowCopy.colChild &&
              row.colResponseCode === matchingRowCopy.colResponseCode &&
              row.colVariableCode === matchingRowCopy.colVariableCode &&
              row.rowChild === matchingRowCopy.rowChild &&
              row.rowResponseCode === matchingRowCopy.rowResponseCode &&
              row.rowVariableCode === matchingRowCopy.rowVariableCode
            ) {
              row.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare_Index;
              row.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare_Index;
              row.ColorCode = matchingRowCopy.ColorCode;
            }
          });

          if (typeof window !== 'undefined') {
            (window as any)['CrossTabData_Index'] = _.cloneDeep(this.crossTabReceivedData);
          }
          return this.calculatePercentage(matchingRowCopy);
        }
      }
      return this.calculatePercentage(matchingRow);
    }
  }

  // getPercentage_RowNest(
  //   rowItem: any,
  //   RowlNestItem: any,
  //   RowNestItemLevel2: any,
  //   colItem: any
  // ): number | string {
  //   (window as any)['CrossTabData_Index'] = [];
  //   if (this.isTranspose) {
  //     const matchingRow = this.crossTabReceivedData.find(
  //       (row: CrossTabOutputItem) => {
  //         if (row.isDerived && row.CalculationType.toLowerCase() == 'mean') {
  //           return (
  //             row.CalculationType.toLowerCase() == 'mean' &&
  //             row.colResponseCode == rowItem.responsecode &&
  //             row.colVariableCode == rowItem.variablecode &&
  //             row.Level1ColResponseCode == RowlNestItem.responsecode &&
  //             row.Level1NestColVariableCode == RowlNestItem.variablecode &&
  //             row.Level2ColResponseCode == RowNestItemLevel2.responsecode &&
  //             row.Level2NestColVariableCode == RowNestItemLevel2.variablecode &&
  //             row.rowResponseCode == colItem.responsecode &&
  //             row.rowVariableCode == colItem.variablecode
  //           );
  //         } else {
  //           return (
  //             row.colResponseCode == rowItem.responsecode &&
  //             row.rowResponseCode == colItem.responsecode &&
  //             row.Level1ColResponseCode == RowlNestItem.responsecode &&
  //             row.colVariableCode == rowItem.variablecode &&
  //             row.rowVariableCode == colItem.variablecode &&
  //             row.Level1NestColVariableCode == RowlNestItem.variablecode &&
  //             row.Level2ColResponseCode == RowNestItemLevel2.responsecode &&
  //             row.Level2NestColVariableCode == RowNestItemLevel2.variablecode
  //           );
  //         }
  //       }
  //     );

  //     return this.calculatePercentage(matchingRow);
  //   } else {
  //     const matchingRow = this.crossTabReceivedData.find(
  //       (row: CrossTabOutputItem) => {
  //         if (row.isDerived && row.CalculationType.toLowerCase() == 'mean') {
  //           return (
  //             row.CalculationType.toLowerCase() == 'mean' &&
  //             row.rowResponseCode == rowItem.responsecode &&
  //             row.rowVariableCode == rowItem.variablecode &&
  //             row.Level1RowResponseCode == RowlNestItem.responsecode &&
  //             row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
  //             row.Level2RowResponseCode == RowNestItemLevel2.responsecode &&
  //             row.Level2NestRowVariableCode == RowNestItemLevel2.variablecode &&
  //             row.colResponseCode == colItem.responsecode &&
  //             row.rowChild == rowItem.Child &&
  //             row.colChild == colItem.Child &&
  //             row.Level1RowChild == RowlNestItem.Child &&
  //             row.Level2RowChild == RowNestItemLevel2.Child &&
  //             row.colVariableCode == colItem.variablecode
  //           );
  //         }
  //         else if (row.isCustomGroup) {
  //           return (
  //             row.isCustomGroup == true &&
  //             row.rowResponseCode == rowItem.responsecode &&
  //             row.rowVariableCode == rowItem.variablecode &&
  //             row.Level1RowResponseCode == RowlNestItem.responsecode &&
  //             row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
  //             row.Level2RowResponseCode == RowNestItemLevel2.responsecode &&
  //             row.Level2NestRowVariableCode == RowNestItemLevel2.variablecode &&
  //             row.colResponseCode == colItem.responsecode &&
  //             row.colVariableCode == colItem.variablecode &&
  //             row.rowChild == rowItem.Child &&
  //             row.colChild == colItem.Child &&
  //             row.Level1RowChild == RowlNestItem.Child &&
  //             row.Level2RowChild == RowNestItemLevel2.Child &&
  //             (row.customGroupId == rowItem.customGroupId ||
  //               row.customGroupId == colItem.customGroupId)
  //           );
  //         } else if (row.isCustomCalculation) {
  //           return (
  //             row.isCustomCalculation == true &&
  //             row.rowResponseCode == rowItem.responsecode &&
  //             row.rowVariableCode == rowItem.variablecode &&
  //             row.Level1RowResponseCode == RowlNestItem.responsecode &&
  //             row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
  //             row.Level2RowResponseCode == RowNestItemLevel2.responsecode &&
  //             row.Level2NestRowVariableCode == RowNestItemLevel2.variablecode &&
  //             row.colResponseCode == colItem.responsecode &&
  //             row.colVariableCode == colItem.variablecode &&
  //             row.rowChild == rowItem.Child &&
  //             row.colChild == colItem.Child &&
  //             row.Level1RowChild == RowlNestItem.Child &&
  //             row.Level2RowChild == RowNestItemLevel2.Child &&
  //             (row.customCalculationId == rowItem.customCalculationId ||
  //               row.customCalculationId == colItem.customCalculationId)
  //           );
  //         } else {
  //           return (
  //             row.rowResponseCode == rowItem.responsecode &&
  //             row.colResponseCode == colItem.responsecode &&
  //             row.Level1RowResponseCode == RowlNestItem.responsecode &&
  //             row.rowVariableCode == rowItem.variablecode &&
  //             row.colVariableCode == colItem.variablecode &&
  //             row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
  //             row.Level2RowResponseCode == RowNestItemLevel2.responsecode &&
  //             row.Level2NestRowVariableCode == RowNestItemLevel2.variablecode &&
  //             row.rowChild == rowItem.Child &&
  //             row.colChild == colItem.Child &&
  //             row.Level1RowChild == RowlNestItem.Child &&
  //             row.Level2RowChild == RowNestItemLevel2.Child
  //           );
  //         }
  //       }
  //     );


  //     if (this.isIndex && this.selectedIndex != "") {
  //       const matchingReferenceRow = this.crossTabReceivedData.find(
  //         (row: CrossTabOutputItem) => {
  //           if (row.isDerived && row.CalculationType.toLowerCase() == 'mean') {
  //             return (
  //               row.CalculationType.toLowerCase() == 'mean' &&
  //               row.rowResponseCode == rowItem.responsecode &&
  //               row.rowVariableCode == rowItem.variablecode &&
  //               row.Level1RowResponseCode == RowlNestItem.responsecode &&
  //               row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
  //               row.Level2RowResponseCode == RowNestItemLevel2.responsecode &&
  //               row.Level2NestRowVariableCode == RowNestItemLevel2.variablecode &&
  //               row.colChild == this.selectedIndex
  //             );
  //           } else {
  //             return (
  //               row.rowResponseCode == rowItem.responsecode &&
  //               row.Level1RowResponseCode == RowlNestItem.responsecode &&
  //               row.rowVariableCode == rowItem.variablecode &&
  //               row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
  //               row.Level2RowResponseCode == RowNestItemLevel2.responsecode &&
  //               row.Level2NestRowVariableCode == RowNestItemLevel2.variablecode &&
  //               row.colChild == this.selectedIndex
  //             );
  //           }
  //         }
  //       );

  //       if (matchingReferenceRow != undefined) {
  //         const matchingRowCopy = { ...matchingRow };
  //         const matchingReferenceRowCopy = { ...matchingReferenceRow };

  //         if (this.selectedWeight == "Unweighted") {
  //           matchingRowCopy.totalUnweightedShare = isNaN(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? null : isFinite(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? (matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) : null;
  //           matchingRowCopy.answerUnweightedShare = isNaN(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? null : isFinite(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? (matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) : null;


  //           matchingRowCopy.totalUnweightedShare_Index = matchingRowCopy.totalUnweightedShare;
  //           matchingRowCopy.answerUnweightedShare_Index = matchingRowCopy.answerUnweightedShare;


  //         }
  //         else {
  //           matchingRowCopy.totalWeightedShare = isNaN(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? null : isFinite(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? (matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) : null;
  //           matchingRowCopy.answerWeightedShare = isNaN(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? null : isFinite(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? (matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) : null;

  //           matchingRowCopy.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare;
  //           matchingRowCopy.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare;
  //         }

  //         let calculatedPercentage: number;
  //         let ShareNumber = this.isTotalBase
  //           ? (this.selectedWeight == "Unweighted" ? matchingRowCopy.totalUnweightedShare_Index : matchingRowCopy.totalWeightedShare_Index)
  //           : (this.selectedWeight == "Unweighted" ? matchingRowCopy.answerUnweightedShare_Index : matchingRowCopy.answerWeightedShare_Index);
  //         if (ShareNumber == null) {
  //           matchingRowCopy.ColorCode = "black";
  //           return '0';
  //         }
  //         else {
  //           calculatedPercentage =
  //             matchingRowCopy.isDerived &&
  //             this.isIndex &&
  //             this.selectedIndex != ''
  //               ? Number((ShareNumber * 100).toFixed(1))
  //               : (matchingRowCopy.isDerived &&
  //                   matchingRowCopy.CalculationType == 'mean') ||
  //                 matchingRow.isCustomCalculation
  //               ? Number(ShareNumber.toFixed(1))
  //               : Number((ShareNumber * 100).toFixed(1));

  //           if (calculatedPercentage < (100 - this.ThresholdValue)) {
  //             matchingRowCopy.ColorCode = "red";
  //           }
  //           else if (calculatedPercentage > (100 + this.ThresholdValue)) {
  //             matchingRowCopy.ColorCode = "green";
  //           }
  //           else {
  //             matchingRowCopy.ColorCode = "black";
  //           }
  //         }
  //         this.crossTabReceivedData.forEach((row: any) => {
  //           if (
  //             row.CalculationType === matchingRowCopy.CalculationType &&
  //             row.Level1ColChild === matchingRowCopy.Level1ColChild &&
  //             row.Level1ColResponseCode === matchingRowCopy.Level1ColResponseCode &&
  //             row.Level1NestColVariableCode === matchingRowCopy.Level1NestColVariableCode &&
  //             row.Level1NestRowVariableCode === matchingRowCopy.Level1NestRowVariableCode &&
  //             row.Level1RowChild === matchingRowCopy.Level1RowChild &&
  //             row.Level1RowResponseCode === matchingRowCopy.Level1RowResponseCode &&
  //             row.Level2ColChild === matchingRowCopy.Level2ColChild &&
  //             row.Level2ColResponseCode === matchingRowCopy.Level2ColResponseCode &&
  //             row.Level2NestColVariableCode === matchingRowCopy.Level2NestColVariableCode &&
  //             row.Level2NestRowVariableCode === matchingRowCopy.Level2NestRowVariableCode &&
  //             row.Level2RowChild === matchingRowCopy.Level2RowChild &&
  //             row.Level2RowResponseCode === matchingRowCopy.Level2RowResponseCode &&
  //             row.colChild === matchingRowCopy.colChild &&
  //             row.colResponseCode === matchingRowCopy.colResponseCode &&
  //             row.colVariableCode === matchingRowCopy.colVariableCode &&
  //             row.rowChild === matchingRowCopy.rowChild &&
  //             row.rowResponseCode === matchingRowCopy.rowResponseCode &&
  //             row.rowVariableCode === matchingRowCopy.rowVariableCode
  //           ) {
  //             row.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare_Index;
  //             row.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare_Index;
  //             row.ColorCode = matchingRowCopy.ColorCode;
  //           }
  //         });

  //         if (typeof window !== 'undefined') {
  //           (window as any)['CrossTabData_Index'] = _.cloneDeep(this.crossTabReceivedData);
  //         }
  //         return this.calculatePercentage(matchingRowCopy);


  //       }
  //     }
  //     return this.calculatePercentage(matchingRow);
  //   }
  // }

  getNestedItemsForMultiple(nestedArray:any[]){
    let brands = _.uniqBy(nestedArray, x => x.brand);
    let metrics = _.uniqBy(nestedArray, x=> x.Child);
    return brands.length * metrics.length;
  }
  getDistinctNestedItemsForMultipleMetrics(nestedArray: any[],snapShotType:String="",level:String=""){
    let columns = [];
    if( this.dropdownLevel1 == 0){
      let metrics = _.uniqBy(nestedArray, x => x.Child)
      let brands = _.uniqBy(nestedArray, x => x.brand);

      columns = metrics;
      // metrics.forEach( (metric:any) => {
      //   brands.forEach( (brand:any)=>{
      //     // let value = _.uniqBy(_.uniqBy(nestedArray, x=> x.Child == metric.Child), x=> x.brand == brand.brand)[0]
      //     let value = _.filter(nestedArray, x=> x.Child == metric.Child &&  x.brand == brand.brand)
      //     value.forEach(element => {
      //       columns.push(element);
      //     });
      //     // columns.push(value);
      //   })
      // })
    }
    else if(this.dropdownLevel1 == 1){
      let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      // columns =_.uniqBy(_.filter(nestedArray, x => x.brand.toLowerCase() == brand[0].name.toLowerCase()), x => x.Child);
      columns =_.uniqBy(nestedArray, x => x.Child);

    }else{
      let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      // columns =_.uniqBy(_.filter(nestedArray, x => x.Child.toLowerCase() == metric[0].name.toLowerCase()), x => x.brand );
      columns =_.uniqBy(_.filter(nestedArray, x => x.Child.toLowerCase() == metric[0].name.toLowerCase()), x => x.Child);
      //columns = _.uniqBy(_.uniqBy( nestedArray, x=> (x.Child.toLowerCase() == metric[0].name.toLowerCase())&& x.brand), x=> x.Child && x.metric)
    }

    return columns;
  }

  getDistinctNestedItemsForWidth(nestedArray: any[],snapShotType:String="",level:String=""){
    let columns = [];
    if( this.dropdownLevel1 == 0){
      let metrics = _.uniqBy(nestedArray, x => x.Child)
      let brands = _.uniqBy(nestedArray, x => x.brand);

      columns = brands;
      // metrics.forEach( (metric:any) => {
      //   brands.forEach( (brand:any)=>{
      //     // let value = _.uniqBy(_.uniqBy(nestedArray, x=> x.Child == metric.Child), x=> x.brand == brand.brand)[0]
      //     let value = _.filter(nestedArray, x=> x.Child == metric.Child &&  x.brand == brand.brand)
      //     value.forEach(element => {
      //       columns.push(element);
      //     });
      //     // columns.push(value);
      //   })
      // })
    }
    else if(this.dropdownLevel1 == 1){
      let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      columns =_.uniqBy(_.filter(nestedArray, x => x.brand.toLowerCase() == brand[0].name.toLowerCase()), x => x.Child);
      //columns =_.uniqBy(_.filter(nestedArray, x => x.brand.toLowerCase() == brand[0].name.toLowerCase()), x => x.brand);
      //columns = _.uniqBy( nestedArray, x=> x.Child && (x.brand.toLowerCase() == brand[0].name.toLowerCase() ));
    }else{
      let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      columns =_.uniqBy(_.filter(nestedArray, x => x.Child.toLowerCase() == metric[0].name.toLowerCase()), x => x.brand );
      //columns =_.uniqBy(nestedArray, x => x.brand );
      //columns = _.uniqBy(_.uniqBy( nestedArray, x=> (x.Child.toLowerCase() == metric[0].name.toLowerCase())&& x.brand), x=> x.Child && x.metric)
    }

    return columns;
  }
  getDistinctNestedItemsForMultipleBrand(nestedArray: any[],snapShotType:String="",level:String=""){
    let columns = [];
    if( this.dropdownLevel1 == 0){
      let metrics = _.uniqBy(nestedArray, x => x.Child)
      let brands = _.uniqBy(nestedArray, x => x.brand);

      columns = brands;
      // metrics.forEach( (metric:any) => {
      //   brands.forEach( (brand:any)=>{
      //     // let value = _.uniqBy(_.uniqBy(nestedArray, x=> x.Child == metric.Child), x=> x.brand == brand.brand)[0]
      //     let value = _.filter(nestedArray, x=> x.Child == metric.Child &&  x.brand == brand.brand)
      //     value.forEach(element => {
      //       columns.push(element);
      //     });
      //     // columns.push(value);
      //   })
      // })
    }
    else if(this.dropdownLevel1 == 1){
      let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      // columns =_.uniqBy(_.filter(nestedArray, x => x.brand.toLowerCase() == brand[0].name.toLowerCase()), x => x.Child);
      columns =_.uniqBy(_.filter(nestedArray, x => x.brand.toLowerCase() == brand[0].name.toLowerCase()), x => x.brand);
      //columns = _.uniqBy( nestedArray, x=> x.Child && (x.brand.toLowerCase() == brand[0].name.toLowerCase() ));
    }else{
      let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      // columns =_.uniqBy(_.filter(nestedArray, x => x.Child.toLowerCase() == metric[0].name.toLowerCase()), x => x.brand );
      columns =_.uniqBy(nestedArray, x => x.brand );
      //columns = _.uniqBy(_.uniqBy( nestedArray, x=> (x.Child.toLowerCase() == metric[0].name.toLowerCase())&& x.brand), x=> x.Child && x.metric)
    }

    return columns;
  }

  getDistinctNestedItemsForBrandMultiple(nestedArray: any[],snapShotType:String="",level:String=""){

    let columns = [];
    if(this.dropdownLevel1 == 0){
      let metrics = _.uniqBy(nestedArray, x => x.Child );
      let brands =  _.uniqBy(nestedArray, x => x.brand );

      metrics.forEach( ()=> {
        brands.forEach((brand:any) => {
          columns.push(brand);
        })
      });
    }
    else if(this.dropdownLevel1 == 1){
      let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      columns =_.uniqBy(_.filter(nestedArray, x => x.brand.toLowerCase() == brand[0].name.toLowerCase()), x => x.Child);
    }else{
      let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      columns =_.uniqBy(_.filter(nestedArray, x => x.Child.toLowerCase() == metric[0].name.toLowerCase()), x => x.brand);
    }


      //columns = _.uniqBy( nestedArray, x=> x.Child && (x.brand.toLowerCase() == brand[0].name.toLowerCase() ));
      // if(this.dropdownLevel1 == 1){
      //   let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      //   const children = new Set();
      //   columns = columns.filter((item)=> item.brand.toLowerCase() == brand[0].name.toLowerCase() )
      // }else{
      //   let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      //   const children = new Set();
      //   columns = columns.filter((item)=> item.Child.toLowerCase() == metric[0].name.toLowerCase() )
      // }
      return columns;
  }

  getDistinctNestedItemsForMetricMultiple(nestedArray: any[],snapShotType:String="",level:String=""){

    let columns;
    if(this.dropdownLevel1 == 0){
      columns = _.uniqBy(nestedArray, x => x.Child );
    }
    else if(this.dropdownLevel1 == 1 ){
      let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      columns =_.uniqBy(_.filter(nestedArray, x => x.brand.toLowerCase() == brand[0].name.toLowerCase()), x => x.Child );
    }else{
      let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      columns =_.uniqBy(_.filter(nestedArray, x => x.Child.toLowerCase() == metric[0].name.toLowerCase()), x => x.Child);
    }
      //columns = _.uniqBy(_.uniqBy( nestedArray, x=> (x.Child.toLowerCase() == metric[0].name.toLowerCase())&& x.brand), x=> x.Child && x.metric)

    // if(this.dropdownLevel1 == 1){
    //   let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
    //   const children = new Set();
    //   columns = columns.filter((item)=> item.brand.toLowerCase() == brand[0].name.toLowerCase() )
    // }else{
    //   let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
    //   const children = new Set();
    //   columns = columns.filter((item)=> item.Child.toLowerCase() == metric[0].name.toLowerCase() )
    // }
    return columns;
  }

  getDistinctNestedItems(nestedArray: any[],snapShotType:String="",level:String=""): any[] {
    // Clone the array to avoid direct mutation
    const clonedArray = _.cloneDeep(nestedArray);

    // Check if the array is empty or undefined
    if (!clonedArray || clonedArray.length < 1) {
        return [];
    }

    // Create a Set to track unique 'Child' values
    const seenChildren = new Set();
    //if(this.defaultShowSampleSize.toLowerCase() == "multiple" && snapShotType!=""){
      if(snapShotType.toLowerCase() == "multiple"){
        if( this.dropdownLevel1 == 1){
          //Select All Metric One Brand
          let distinctItems;
          let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
          const children = new Set();
          if(level.toLowerCase() == "metric"){
            distinctItems = clonedArray.filter((item: any) => {
              if (!seenChildren.has(item.Child) && brand[0].name.toLowerCase() == item.brand.toLowerCase()){
                  seenChildren.add(item.Child);
                  return true;
              }
              return false;

            //   if (!children.has(item.brand) && brand[0].name.toLowerCase() == item.brand.toLowerCase()){
            //     seenChildren.push(item.Child);
            //     children.add(item.brand)
            //     return true;
            // }
            // return false;
            });
          }else{
            distinctItems = clonedArray.filter((item: any) => {
              if (!seenChildren.has(item.brand) && brand[0].name.toLowerCase() == item.brand.toLowerCase()){
                  seenChildren.add(item.brand);
                  return true;
              }
              return false;

            //   if (!children.has(item.Child) && brand[0].name.toLowerCase() == item.brand.toLowerCase()){
            //     seenChildren.push(item.brand);
            //     children.add(item.Child);
            //     return true;
            // }
            // return false;
            });
          }
          return distinctItems;
        }else{
          //Select one Metric All Brand
          let distinctItems;
          let metric = this.dropdownLevel2.filter((item:any)=>item.is_selected == true);
          if(level.toLowerCase() == "metric"){
            distinctItems = clonedArray.filter((item: any) => {
              if (!seenChildren.has(item.Child) && metric[0].name.toLowerCase() == item.Child.toLowerCase()){
                  seenChildren.add(item.Child);
                  return true;
              }
              return false;
            });
          }else{
            distinctItems = clonedArray.filter((item: any) => {
              if (!seenChildren.has(item.brand) && metric[0].name.toLowerCase() == item.Child.toLowerCase()){
                  seenChildren.add(item.brand);
                  return true;
              }
              return false;
            });
          }
          return distinctItems;
        }
      }
    //}

    //const seenChildren = new Set();

    // Filter the array to include only the first occurrence of each distinct 'Child'
    const distinctItems = clonedArray.filter((item: any) => {
        if (!seenChildren.has(item.Child)) {
            seenChildren.add(item.Child);
            return true;
        }
        return false;
    });

    return distinctItems;
}


  getPercentage_RowNest(rowItem: any,
    RowlNestItem: any,
    RowNestItemLevel2: any,
    colItem: any): number | string {
    let colChild=colItem.Child;
    // let rowToColChild=RowlNestItem.Level1ColChild;
    let rowChild=RowlNestItem.Child;
    RowlNestItem=_.cloneDeep(rowItem).NestedArray.find((a:any)=>a.Level1ColChild==colChild && a.Child==rowChild);
    if (this.staticTimePeriod == true) {
      RowlNestItem =_.cloneDeep(rowItem).NestedArray.find((a:any)=>a.Child==rowChild);
    }
    if(!this.TrendToggleOn){
         return this.SelectedWeight(RowlNestItem);
         //return !this.weightedBaseInput ? (RowlNestItem.unweightedBase == null ? '0' : Math.round(RowlNestItem.unweightedBase)) : (RowlNestItem.weightedBase == null ? '0' : Math.round(RowlNestItem.weightedBase));
    }
    else{
       if(RowlNestItem.trend)
         return this.SelectedWeight(RowlNestItem);//!this.weightedBaseInput ? (RowlNestItem.unweightedBase == null ? '0' : Math.round(RowlNestItem.unweightedBase)) : (RowlNestItem.weightedBase == null ? '0' : Math.round(RowlNestItem.weightedBase));
       else
         return 'NC';
    }
  }

  getPercentage_RowNestMultiple(rowItem: any,
    brandValue: any,
    metricValue:any,
    RowNestItemLevel2: any,
    colItem: any): number | string {
     // As we have discussed with Domain, if unweighted or weightedBaseInput value is null then we have to show NA
    let colChild=colItem.Child;
    let metrics = metricValue.Child;
    let brand = brandValue.brand;
    // let rowToColChild=RowlNestItem.Level1ColChild;
    // let rowChild=RowlNestItem.Child;
    // let brand = brandValue.brand;
    let RowlNestItem =_.cloneDeep(rowItem).NestedArray.find((a:any)=>a.Level1ColChild==colChild && a.Child.includes(metrics) && a.brand == brand);

    if(this.staticTimePeriod){
        RowlNestItem =_.cloneDeep(rowItem).NestedArray.find((a:any)=>a.Child.includes(metrics) && a.brand == brand);
    }

    if(!this.TrendToggleOn){
         return this.SelectedWeight(RowlNestItem);//!this.weightedBaseInput ? (RowlNestItem.unweightedBase == null ? '0' : Math.round(RowlNestItem.unweightedBase)) : (RowlNestItem.weightedBase == null ? '0' : Math.round(RowlNestItem.weightedBase));
    }
    else{
       if(RowlNestItem.trend)
         return this.SelectedWeight(RowlNestItem);//!this.weightedBaseInput ? (RowlNestItem.unweightedBase == null ? '0' : Math.round(RowlNestItem.unweightedBase)) : (RowlNestItem.weightedBase == null ? '0' : Math.round(RowlNestItem.weightedBase));
       else
         return 'NC';
    }

  }

  SelectedWeight(RowlNestItem:any){
       if(this.selectedweight == "Weighted Base"){
          let val = RowlNestItem?.weightedBase;
          return (val == null || val == 0) ? 'NA' : Math.round(val);
       }
       else if(this.selectedweight == "Sample Size"){
          let val = RowlNestItem?.unweightedBase;
          return (val == null || val == 0) ? 'NA' : Math.round(val);
       }
       else if(this.selectedweight == "Weighted Numerator"){
          let val = RowlNestItem?.WeightedNumerator;
          return (val == null || val == 0) ? 'NA' : Math.round(val);
       }
       else{
          let val = RowlNestItem?.UnweightedNumerator;
          return (val == null || val == 0) ? 'NA' : Math.round(val);
       }
  }

  getPercentage_multiLevel(
    rowItem: any,
    RowlNestItem: any,
    colItem: any,
    colNestItem: any
  ): number | string {
    //Find the row that matches the response codes

    (window as any)['CrossTabData_Index'] = [];

    if (this.isTranspose) {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) =>
          row.isDerived && row.CalculationType.toLowerCase() == 'mean'
            ? row.colResponseCode == rowItem.responsecode &&
            row.colVariableCode == rowItem.variablecode &&
            row.Level1ColResponseCode == RowlNestItem.responsecode &&
            row.Level1NestColVariableCode == RowlNestItem.variablecode &&
            row.rowResponseCode == colItem.responsecode &&
            row.rowVariableCode == colItem.variablecode &&
            row.Level1RowResponseCode == colNestItem.responsecode &&
            row.Level1NestRowVariableCode == colNestItem.variablecode &&
            row.CalculationType.toLowerCase() == 'mean'
            : row.colResponseCode == rowItem.responsecode &&
            row.Level1ColResponseCode == RowlNestItem.responsecode &&
            row.rowResponseCode == colItem.responsecode &&
            row.Level1RowResponseCode == colNestItem.responsecode &&
            row.colVariableCode == rowItem.variablecode &&
            row.rowVariableCode == colItem.variablecode &&
            row.Level1NestColVariableCode == RowlNestItem.variablecode &&
            row.Level1NestRowVariableCode == colNestItem.variablecode
      );
      return this.calculatePercentage(matchingRow);
    } else {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) =>
          row.isDerived && row.CalculationType.toLowerCase() == 'mean'
            ? row.rowResponseCode == rowItem.responsecode &&
            row.rowVariableCode == rowItem.variablecode &&
            row.Level1RowResponseCode == RowlNestItem.responsecode &&
            row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
            row.colResponseCode == colItem.responsecode &&
            row.colVariableCode == colItem.variablecode &&
            row.Level1ColResponseCode == colNestItem.responsecode &&
            row.Level1NestColVariableCode == colNestItem.variablecode &&
            row.CalculationType.toLowerCase() == 'mean' && row.rowChild == rowItem.Child &&
            row.Level1RowChild == RowlNestItem.Child &&
            row.colChild == colItem.Child &&
            row.Level1ColChild == colNestItem.Child
            :
            row.isCustomGroup
              ? row.rowResponseCode == rowItem.responsecode &&
              row.rowVariableCode == rowItem.variablecode &&
              row.Level1RowResponseCode == RowlNestItem.responsecode &&
              row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
              row.colResponseCode == colItem.responsecode &&
              row.colVariableCode == colItem.variablecode &&
              row.Level1ColResponseCode == colNestItem.responsecode &&
              row.Level1NestColVariableCode == colNestItem.variablecode &&
              row.isCustomGroup == true &&
              (row.customGroupId == rowItem.customGroupId || row.customGroupId == colItem.customGroupId) &&
              row.rowChild == rowItem.Child &&
              row.Level1RowChild == RowlNestItem.Child &&
              row.colChild == colItem.Child &&
              row.Level1ColChild == colNestItem.Child :

              row.isCustomCalculation
                ? row.rowResponseCode == rowItem.responsecode &&
                row.rowVariableCode == rowItem.variablecode &&
                row.Level1RowResponseCode == RowlNestItem.responsecode &&
                row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
                row.colResponseCode == colItem.responsecode &&
                row.colVariableCode == colItem.variablecode &&
                row.Level1ColResponseCode == colNestItem.responsecode &&
                row.Level1NestColVariableCode == colNestItem.variablecode &&
                row.isCustomCalculation == true &&
                (row.customCalculationId == rowItem.customCalculationId || row.customCalculationId == colItem.customCalculationId) &&
                row.rowChild == rowItem.Child &&
                row.Level1RowChild == RowlNestItem.Child &&
                row.colChild == colItem.Child &&
                row.Level1ColChild == colNestItem.Child :

                row.rowResponseCode == rowItem.responsecode &&
                row.Level1RowResponseCode == RowlNestItem.responsecode &&
                row.colResponseCode == colItem.responsecode &&
                row.Level1ColResponseCode == colNestItem.responsecode &&
                row.rowVariableCode == rowItem.variablecode &&
                row.colVariableCode == colItem.variablecode &&
                row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
                row.Level1NestColVariableCode == colNestItem.variablecode &&
                row.rowChild == rowItem.Child &&
                row.Level1RowChild == RowlNestItem.Child &&
                row.colChild == colItem.Child &&
                row.Level1ColChild == colNestItem.Child
      );

      if (this.isIndex && this.selectedIndex != "") {
        const matchingReferenceRow = this.crossTabReceivedData.find(
          (row: CrossTabOutputItem) =>
            row.isDerived && row.CalculationType.toLowerCase() == 'mean'
              ? row.rowResponseCode == rowItem.responsecode &&
              row.rowVariableCode == rowItem.variablecode &&
              row.Level1RowResponseCode == RowlNestItem.responsecode &&
              row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
              row.colResponseCode == colItem.responsecode &&
              row.colVariableCode == colItem.variablecode &&
              row.Level1ColChild == this.selectedIndex &&
              row.CalculationType.toLowerCase() == 'mean'
              : row.rowResponseCode == rowItem.responsecode &&
              row.Level1RowResponseCode == RowlNestItem.responsecode &&
              row.colResponseCode == colItem.responsecode &&
              row.rowVariableCode == rowItem.variablecode &&
              row.colVariableCode == colItem.variablecode &&
              row.Level1NestRowVariableCode == RowlNestItem.variablecode &&
              row.Level1ColChild == this.selectedIndex
        );

        if (matchingReferenceRow != undefined) {
          const matchingRowCopy = { ...matchingRow };
          const matchingReferenceRowCopy = { ...matchingReferenceRow };

          if (this.selectedWeight == "Unweighted") {
            matchingRowCopy.totalUnweightedShare = isNaN(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? null : isFinite(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? (matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) : null;
            matchingRowCopy.answerUnweightedShare = isNaN(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? null : isFinite(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? (matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) : null;

            matchingRowCopy.totalUnweightedShare_Index = matchingRowCopy.totalUnweightedShare;
            matchingRowCopy.answerUnweightedShare_Index = matchingRowCopy.answerUnweightedShare;
          }
          else {
            matchingRowCopy.totalWeightedShare = isNaN(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? null : isFinite(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? (matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) : null;
            matchingRowCopy.answerWeightedShare = isNaN(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? null : isFinite(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? (matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) : null;

            matchingRowCopy.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare;
            matchingRowCopy.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare;
          }

          let calculatedPercentage: number;
          let ShareNumber = this.isTotalBase
            ? (this.selectedWeight == "Unweighted" ? matchingRowCopy.totalUnweightedShare_Index : matchingRowCopy.totalWeightedShare_Index)
            : (this.selectedWeight == "Unweighted" ? matchingRowCopy.answerUnweightedShare_Index : matchingRowCopy.answerWeightedShare_Index);
          if (ShareNumber == null) {
            matchingRowCopy.ColorCode = "black";
            return '0';
          }
          else {
            calculatedPercentage =
              matchingRowCopy.isDerived &&
                this.isIndex &&
                this.selectedIndex != ''
                ? Number((ShareNumber * 100).toFixed(1))
                : (matchingRowCopy.isDerived &&
                  matchingRowCopy.CalculationType == 'mean') ||
                  matchingRow.isCustomCalculation
                  ? Number(ShareNumber.toFixed(1))
                  : Number((ShareNumber * 100).toFixed(1));

            if (calculatedPercentage < (100 - this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "red";
            }
            else if (calculatedPercentage > (100 + this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "green";
            }
            else {
              matchingRowCopy.ColorCode = "black";
            }
          }

          this.crossTabReceivedData.forEach((row: any) => {
            if (
              row.CalculationType === matchingRowCopy.CalculationType &&
              row.Level1ColChild === matchingRowCopy.Level1ColChild &&
              row.Level1ColResponseCode === matchingRowCopy.Level1ColResponseCode &&
              row.Level1NestColVariableCode === matchingRowCopy.Level1NestColVariableCode &&
              row.Level1NestRowVariableCode === matchingRowCopy.Level1NestRowVariableCode &&
              row.Level1RowChild === matchingRowCopy.Level1RowChild &&
              row.Level1RowResponseCode === matchingRowCopy.Level1RowResponseCode &&
              row.Level2ColChild === matchingRowCopy.Level2ColChild &&
              row.Level2ColResponseCode === matchingRowCopy.Level2ColResponseCode &&
              row.Level2NestColVariableCode === matchingRowCopy.Level2NestColVariableCode &&
              row.Level2NestRowVariableCode === matchingRowCopy.Level2NestRowVariableCode &&
              row.Level2RowChild === matchingRowCopy.Level2RowChild &&
              row.Level2RowResponseCode === matchingRowCopy.Level2RowResponseCode &&
              row.colChild === matchingRowCopy.colChild &&
              row.colResponseCode === matchingRowCopy.colResponseCode &&
              row.colVariableCode === matchingRowCopy.colVariableCode &&
              row.rowChild === matchingRowCopy.rowChild &&
              row.rowResponseCode === matchingRowCopy.rowResponseCode &&
              row.rowVariableCode === matchingRowCopy.rowVariableCode
            ) {
              row.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare_Index;
              row.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare_Index;
              row.ColorCode = matchingRowCopy.ColorCode;
            }
          });

          if (typeof window !== 'undefined') {
            (window as any)['CrossTabData_Index'] = _.cloneDeep(this.crossTabReceivedData);
          }
          return this.calculatePercentage(matchingRowCopy);
        }
      }
      return this.calculatePercentage(matchingRow);
    }
  }

  getPercentage_multiLevel_level2(
    rowLevel0: any,
    rowLevel1: any,
    rowLevel2: any,
    colLevel0: any,
    colLevel1: any,
    colLevel2: any
  ): number | string {
    //Find the row that matches the response codes
    (window as any)['CrossTabData_Index'] = [];

    if (this.isTranspose) {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) =>
          row.isDerived && row.CalculationType.toLowerCase() == 'mean'
            ? row.rowResponseCode == colLevel0.responsecode &&
            row.Level1RowResponseCode == colLevel1.responsecode &&
            row.Level2RowResponseCode == colLevel2.responsecode &&
            row.colVariableCode == rowLevel0.variablecode &&
            row.Level1NestColVariableCode == rowLevel1.variablecode &&
            row.Level2NestColVariableCode == rowLevel2.variablecode &&
            row.rowVariableCode == colLevel0.variablecode &&
            row.Level1NestRowVariableCode == colLevel1.variablecode &&
            row.Level2NestRowVariableCode == colLevel2.variablecode &&
            row.CalculationType.toLowerCase() == 'mean'
            : row.colResponseCode == rowLevel0.responsecode &&
            row.Level1ColResponseCode == rowLevel1.responsecode &&
            row.Level2ColResponseCode == rowLevel2.responsecode &&
            row.rowResponseCode == colLevel0.responsecode &&
            row.Level1RowResponseCode == colLevel1.responsecode &&
            row.Level2RowResponseCode == colLevel2.responsecode &&
            row.colVariableCode == rowLevel0.variablecode &&
            row.Level1NestColVariableCode == rowLevel1.variablecode &&
            row.Level2NestColVariableCode == rowLevel2.variablecode &&
            row.rowVariableCode == colLevel0.variablecode &&
            row.Level1NestRowVariableCode == colLevel1.variablecode &&
            row.Level2NestRowVariableCode == colLevel2.variablecode
      );
      return this.calculatePercentage(matchingRow);
    } else {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) =>
          row.isDerived && row.CalculationType.toLowerCase() == 'mean'
            ? row.rowResponseCode == rowLevel0.responsecode &&
            row.rowVariableCode == rowLevel0.variablecode &&
            row.Level1RowResponseCode == rowLevel1.responsecode &&
            row.Level1NestRowVariableCode == rowLevel1.variablecode &&
            row.Level2RowResponseCode == rowLevel2.responsecode &&
            row.Level2NestRowVariableCode == rowLevel2.variablecode &&
            row.colResponseCode == colLevel0.responsecode &&
            row.colVariableCode == colLevel0.variablecode &&
            row.Level1ColResponseCode == colLevel1.responsecode &&
            row.Level1NestColVariableCode == colLevel1.variablecode &&
            row.Level2ColResponseCode == colLevel2.responsecode &&
            row.Level2NestColVariableCode == colLevel2.variablecode &&
            row.CalculationType.toLowerCase() == 'mean' &&
            row.rowChild == rowLevel0.Child &&
            row.Level1RowChild == rowLevel1.Child &&
            row.Level2RowChild == rowLevel2.Child &&
            row.colChild == colLevel0.Child &&
            row.Level1ColChild == colLevel1.Child &&
            row.Level2ColChild == colLevel2.Child :
            row.isCustomGroup
              ? row.rowResponseCode == rowLevel0.responsecode &&
              row.rowVariableCode == rowLevel0.variablecode &&
              row.Level1RowResponseCode == rowLevel1.responsecode &&
              row.Level1NestRowVariableCode == rowLevel1.variablecode &&
              row.Level2RowResponseCode == rowLevel2.responsecode &&
              row.Level2NestRowVariableCode == rowLevel2.variablecode &&
              row.colResponseCode == colLevel0.responsecode &&
              row.colVariableCode == colLevel0.variablecode &&
              row.Level1ColResponseCode == colLevel1.responsecode &&
              row.Level1NestColVariableCode == colLevel1.variablecode &&
              row.Level2ColResponseCode == colLevel2.responsecode &&
              row.Level2NestColVariableCode == colLevel2.variablecode &&
              row.isCustomGroup == true && (row.customGroupId == rowLevel0.customGroupId || row.customGroupId == colLevel2.customGroupId) &&
              row.rowChild == rowLevel0.Child &&
              row.Level1RowChild == rowLevel1.Child &&
              row.Level2RowChild == rowLevel2.Child &&
              row.colChild == colLevel0.Child &&
              row.Level1ColChild == colLevel1.Child &&
              row.Level2ColChild == colLevel2.Child :
              row.isCustomCalculation ?
                row.rowResponseCode == rowLevel0.responsecode &&
                row.rowVariableCode == rowLevel0.variablecode &&
                row.Level1RowResponseCode == rowLevel1.responsecode &&
                row.Level1NestRowVariableCode == rowLevel1.variablecode &&
                row.Level2RowResponseCode == rowLevel2.responsecode &&
                row.Level2NestRowVariableCode == rowLevel2.variablecode &&
                row.colResponseCode == colLevel0.responsecode &&
                row.colVariableCode == colLevel0.variablecode &&
                row.Level1ColResponseCode == colLevel1.responsecode &&
                row.Level1NestColVariableCode == colLevel1.variablecode &&
                row.Level2ColResponseCode == colLevel2.responsecode &&
                row.Level2NestColVariableCode == colLevel2.variablecode &&
                row.isCustomCalculation == true && (row.customCalculationId == rowLevel0.customCalculationId || row.customCalculationId == colLevel2.customCalculationId) &&
                row.rowChild == rowLevel0.Child &&
                row.Level1RowChild == rowLevel1.Child &&
                row.Level2RowChild == rowLevel2.Child &&
                row.colChild == colLevel0.Child &&
                row.Level1ColChild == colLevel1.Child &&
                row.Level2ColChild == colLevel2.Child
                : row.rowResponseCode == rowLevel0.responsecode &&
                row.Level1RowResponseCode == rowLevel1.responsecode &&
                row.Level2RowResponseCode == rowLevel2.responsecode &&
                row.colResponseCode == colLevel0.responsecode &&
                row.Level1ColResponseCode == colLevel1.responsecode &&
                row.Level2ColResponseCode == colLevel2.responsecode &&
                row.rowVariableCode == rowLevel0.variablecode &&
                row.Level1NestRowVariableCode == rowLevel1.variablecode &&
                row.Level2NestRowVariableCode == rowLevel2.variablecode &&
                row.colVariableCode == colLevel0.variablecode &&
                row.Level1NestColVariableCode == colLevel1.variablecode &&
                row.Level2NestColVariableCode == colLevel2.variablecode &&
                row.rowChild == rowLevel0.Child &&
                row.Level1RowChild == rowLevel1.Child &&
                row.Level2RowChild == rowLevel2.Child &&
                row.colChild == colLevel0.Child &&
                row.Level1ColChild == colLevel1.Child &&
                row.Level2ColChild == colLevel2.Child
      );


      if (this.isIndex && this.selectedIndex != "") {

        const matchingReferenceRow = this.crossTabReceivedData.find(
          (row: CrossTabOutputItem) =>
            row.isDerived && row.CalculationType.toLowerCase() == 'mean'
              ? row.rowResponseCode == rowLevel0.responsecode &&
              row.rowVariableCode == rowLevel0.variablecode &&
              row.Level1RowResponseCode == rowLevel1.responsecode &&
              row.Level1NestRowVariableCode == rowLevel1.variablecode &&
              row.Level2RowResponseCode == rowLevel2.responsecode &&
              row.Level2NestRowVariableCode == rowLevel2.variablecode &&
              row.colResponseCode == colLevel0.responsecode &&
              row.colVariableCode == colLevel0.variablecode &&
              row.Level1ColResponseCode == colLevel1.responsecode &&
              row.Level1NestColVariableCode == colLevel1.variablecode &&
              row.Level2ColChild == this.selectedIndex &&
              row.CalculationType.toLowerCase() == 'mean'
              : row.rowResponseCode == rowLevel0.responsecode &&
              row.Level1RowResponseCode == rowLevel1.responsecode &&
              row.Level2RowResponseCode == rowLevel2.responsecode &&
              row.colResponseCode == colLevel0.responsecode &&
              row.Level1ColResponseCode == colLevel1.responsecode &&
              row.rowVariableCode == rowLevel0.variablecode &&
              row.Level1NestRowVariableCode == rowLevel1.variablecode &&
              row.Level2NestRowVariableCode == rowLevel2.variablecode &&
              row.colVariableCode == colLevel0.variablecode &&
              row.Level1NestColVariableCode == colLevel1.variablecode &&
              row.Level2ColChild == this.selectedIndex
        );

        if (matchingReferenceRow != undefined) {
          const matchingRowCopy = { ...matchingRow };
          const matchingReferenceRowCopy = { ...matchingReferenceRow };

          if (this.selectedWeight == "Unweighted") {
            matchingRowCopy.totalUnweightedShare = isNaN(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? null : isFinite(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? (matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) : null;
            matchingRowCopy.answerUnweightedShare = isNaN(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? null : isFinite(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? (matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) : null;

            matchingRowCopy.totalUnweightedShare_Index = matchingRowCopy.totalUnweightedShare;
            matchingRowCopy.answerUnweightedShare_Index = matchingRowCopy.answerUnweightedShare;

          }
          else {
            matchingRowCopy.totalWeightedShare = isNaN(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? null : isFinite(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? (matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) : null;
            matchingRowCopy.answerWeightedShare = isNaN(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? null : isFinite(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? (matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) : null;

            matchingRowCopy.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare;
            matchingRowCopy.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare;
          }
          let calculatedPercentage: number;
          let ShareNumber = this.isTotalBase
            ? (this.selectedWeight == "Unweighted" ? matchingRowCopy.totalUnweightedShare_Index : matchingRowCopy.totalWeightedShare_Index)
            : (this.selectedWeight == "Unweighted" ? matchingRowCopy.answerUnweightedShare_Index : matchingRowCopy.answerWeightedShare_Index);
          if (ShareNumber == null) {
            matchingRowCopy.ColorCode = "black";
            return '0';
          }
          else {
            calculatedPercentage =
              matchingRowCopy.isDerived &&
                this.isIndex &&
                this.selectedIndex != ''
                ? Number((ShareNumber * 100).toFixed(1))
                : (matchingRowCopy.isDerived &&
                  matchingRowCopy.CalculationType == 'mean') ||
                  matchingRow.isCustomCalculation
                  ? Number(ShareNumber.toFixed(1))
                  : Number((ShareNumber * 100).toFixed(1));

            if (calculatedPercentage < (100 - this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "red";
            }
            else if (calculatedPercentage > (100 + this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "green";
            }
            else {
              matchingRowCopy.ColorCode = "black";
            }
          }

          this.crossTabReceivedData.forEach((row: any) => {
            if (
              row.CalculationType === matchingRowCopy.CalculationType &&
              row.Level1ColChild === matchingRowCopy.Level1ColChild &&
              row.Level1ColResponseCode === matchingRowCopy.Level1ColResponseCode &&
              row.Level1NestColVariableCode === matchingRowCopy.Level1NestColVariableCode &&
              row.Level1NestRowVariableCode === matchingRowCopy.Level1NestRowVariableCode &&
              row.Level1RowChild === matchingRowCopy.Level1RowChild &&
              row.Level1RowResponseCode === matchingRowCopy.Level1RowResponseCode &&
              row.Level2ColChild === matchingRowCopy.Level2ColChild &&
              row.Level2ColResponseCode === matchingRowCopy.Level2ColResponseCode &&
              row.Level2NestColVariableCode === matchingRowCopy.Level2NestColVariableCode &&
              row.Level2NestRowVariableCode === matchingRowCopy.Level2NestRowVariableCode &&
              row.Level2RowChild === matchingRowCopy.Level2RowChild &&
              row.Level2RowResponseCode === matchingRowCopy.Level2RowResponseCode &&
              row.colChild === matchingRowCopy.colChild &&
              row.colResponseCode === matchingRowCopy.colResponseCode &&
              row.colVariableCode === matchingRowCopy.colVariableCode &&
              row.rowChild === matchingRowCopy.rowChild &&
              row.rowResponseCode === matchingRowCopy.rowResponseCode &&
              row.rowVariableCode === matchingRowCopy.rowVariableCode
            ) {
              row.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare_Index;
              row.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare_Index;
              row.ColorCode = matchingRowCopy.ColorCode;
            }
          });

          if (typeof window !== 'undefined') {
            (window as any)['CrossTabData_Index'] = _.cloneDeep(this.crossTabReceivedData);
          }
          return this.calculatePercentage(matchingRowCopy);
        }
      }

      return this.calculatePercentage(matchingRow);
    }
  }

  getPercentage_multiLevel_Row_Level1(
    rowLevel0: any,
    rowLevel1: any,
    rowLevel2: any,
    colLevel0: any,
    colLevel1: any
  ): number | string {
    //Find the row that matches the response codes

    (window as any)['CrossTabData_Index'] = [];

    if (this.isTranspose) {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) =>
          row.isDerived && row.CalculationType.toLowerCase() == 'mean'
            ? row.rowResponseCode == colLevel0.responsecode &&
            row.Level1RowResponseCode == colLevel1.responsecode &&
            row.colVariableCode == rowLevel0.variablecode &&
            row.Level1NestColVariableCode == rowLevel1.variablecode &&
            row.Level2NestColVariableCode == rowLevel2.variablecode &&
            row.rowVariableCode == colLevel0.variablecode &&
            row.Level1NestRowVariableCode == colLevel1.variablecode &&
            row.CalculationType.toLowerCase() == 'mean'
            : row.colResponseCode == rowLevel0.responsecode &&
            row.Level1ColResponseCode == rowLevel1.responsecode &&
            row.Level2ColResponseCode == rowLevel2.responsecode &&
            row.rowResponseCode == colLevel0.responsecode &&
            row.Level1RowResponseCode == colLevel1.responsecode &&
            row.colVariableCode == rowLevel0.variablecode &&
            row.Level1NestColVariableCode == rowLevel1.variablecode &&
            row.Level2NestColVariableCode == rowLevel2.variablecode &&
            row.rowVariableCode == colLevel0.variablecode &&
            row.Level1NestRowVariableCode == colLevel1.variablecode
      );
      return this.calculatePercentage(matchingRow);
    } else {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) =>
          row.isDerived && row.CalculationType.toLowerCase() == 'mean'
            ? row.rowResponseCode == rowLevel0.responsecode &&
            row.rowVariableCode == rowLevel0.variablecode &&
            row.Level1RowResponseCode == rowLevel1.responsecode &&
            row.Level1NestRowVariableCode == rowLevel1.variablecode &&
            row.Level2RowResponseCode == rowLevel2.responsecode &&
            row.Level2NestRowVariableCode == rowLevel2.variablecode &&
            row.colResponseCode == colLevel0.responsecode &&
            row.colVariableCode == colLevel0.variablecode &&
            row.Level1ColResponseCode == colLevel1.responsecode &&
            row.Level1NestColVariableCode == colLevel1.variablecode &&
            row.CalculationType.toLowerCase() == 'mean' &&
            row.rowChild == rowLevel0.Child &&
            row.Level1RowChild == rowLevel1.Child &&
            row.Level2RowChild == rowLevel2.Child &&
            row.colChild == colLevel0.Child &&
            row.Level1ColChild == colLevel1.Child
            : row.isCustomGroup
              ? row.rowResponseCode == rowLevel0.responsecode &&
              row.rowVariableCode == rowLevel0.variablecode &&
              row.Level1RowResponseCode == rowLevel1.responsecode &&
              row.Level1NestRowVariableCode == rowLevel1.variablecode &&
              row.Level2RowResponseCode == rowLevel2.responsecode &&
              row.Level2NestRowVariableCode == rowLevel2.variablecode &&
              row.colResponseCode == colLevel0.responsecode &&
              row.colVariableCode == colLevel0.variablecode &&
              row.Level1ColResponseCode == colLevel1.responsecode &&
              row.Level1NestColVariableCode == colLevel1.variablecode &&
              row.isCustomGroup == true &&
              (row.customGroupId == rowLevel0.customGroupId ||
                row.customGroupId == colLevel1.customGroupId) &&
              row.rowChild == rowLevel0.Child &&
              row.Level1RowChild == rowLevel1.Child &&
              row.Level2RowChild == rowLevel2.Child &&
              row.colChild == colLevel0.Child &&
              row.Level1ColChild == colLevel1.Child
              : row.isCustomCalculation
                ? row.rowResponseCode == rowLevel0.responsecode &&
                row.rowVariableCode == rowLevel0.variablecode &&
                row.Level1RowResponseCode == rowLevel1.responsecode &&
                row.Level1NestRowVariableCode == rowLevel1.variablecode &&
                row.Level2RowResponseCode == rowLevel2.responsecode &&
                row.Level2NestRowVariableCode == rowLevel2.variablecode &&
                row.colResponseCode == colLevel0.responsecode &&
                row.colVariableCode == colLevel0.variablecode &&
                row.Level1ColResponseCode == colLevel1.responsecode &&
                row.Level1NestColVariableCode == colLevel1.variablecode &&
                row.isCustomCalculation == true &&
                (row.customCalculationId == rowLevel0.customCalculationId ||
                  row.customCalculationId == colLevel1.customCalculationId) &&
                row.rowChild == rowLevel0.Child &&
                row.Level1RowChild == rowLevel1.Child &&
                row.Level2RowChild == rowLevel2.Child &&
                row.colChild == colLevel0.Child &&
                row.Level1ColChild == colLevel1.Child
                :
                row.rowResponseCode == rowLevel0.responsecode &&
                row.Level1RowResponseCode == rowLevel1.responsecode &&
                row.Level2RowResponseCode == rowLevel2.responsecode &&
                row.colResponseCode == colLevel0.responsecode &&
                row.Level1ColResponseCode == colLevel1.responsecode &&
                row.rowVariableCode == rowLevel0.variablecode &&
                row.Level1NestRowVariableCode == rowLevel1.variablecode &&
                row.Level2NestRowVariableCode == rowLevel2.variablecode &&
                row.colVariableCode == colLevel0.variablecode &&
                row.Level1NestColVariableCode == colLevel1.variablecode &&
                row.rowChild == rowLevel0.Child &&
                row.Level1RowChild == rowLevel1.Child &&
                row.Level2RowChild == rowLevel2.Child &&
                row.colChild == colLevel0.Child &&
                row.Level1ColChild == colLevel1.Child
      );
      if (this.isIndex && this.selectedIndex != "") {
        const matchingReferenceRow = this.crossTabReceivedData.find(
          (row: CrossTabOutputItem) =>
            row.isDerived && row.CalculationType.toLowerCase() == 'mean'
              ? row.rowResponseCode == rowLevel0.responsecode &&
              row.rowVariableCode == rowLevel0.variablecode &&
              row.Level1RowResponseCode == rowLevel1.responsecode &&
              row.Level1NestRowVariableCode == rowLevel1.variablecode &&
              row.Level2RowResponseCode == rowLevel2.responsecode &&
              row.Level2NestRowVariableCode == rowLevel2.variablecode &&
              row.colResponseCode == colLevel0.responsecode &&
              row.colVariableCode == colLevel0.variablecode &&
              row.Level1ColChild == this.selectedIndex &&
              row.CalculationType.toLowerCase() == 'mean'
              : row.rowResponseCode == rowLevel0.responsecode &&
              row.Level1RowResponseCode == rowLevel1.responsecode &&
              row.Level2RowResponseCode == rowLevel2.responsecode &&
              row.colResponseCode == colLevel0.responsecode &&
              row.rowVariableCode == rowLevel0.variablecode &&
              row.Level1NestRowVariableCode == rowLevel1.variablecode &&
              row.Level2NestRowVariableCode == rowLevel2.variablecode &&
              row.colVariableCode == colLevel0.variablecode &&
              row.Level1ColChild == this.selectedIndex
        );

        if (matchingReferenceRow != undefined) {
          const matchingRowCopy = { ...matchingRow };
          const matchingReferenceRowCopy = { ...matchingReferenceRow };

          if (this.selectedWeight == "Unweighted") {
            matchingRowCopy.totalUnweightedShare = isNaN(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? null : isFinite(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? (matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) : null;
            matchingRowCopy.answerUnweightedShare = isNaN(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? null : isFinite(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? (matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) : null;

            matchingRowCopy.totalUnweightedShare_Index = matchingRowCopy.totalUnweightedShare;
            matchingRowCopy.answerUnweightedShare_Index = matchingRowCopy.answerUnweightedShare;

          }
          else {
            matchingRowCopy.totalWeightedShare = isNaN(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? null : isFinite(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? (matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) : null;
            matchingRowCopy.answerWeightedShare = isNaN(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? null : isFinite(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? (matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) : null;

            matchingRowCopy.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare;
            matchingRowCopy.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare;

          }
          let calculatedPercentage: number;
          let ShareNumber = this.isTotalBase
            ? (this.selectedWeight == "Unweighted" ? matchingRowCopy.totalUnweightedShare_Index : matchingRowCopy.totalWeightedShare_Index)
            : (this.selectedWeight == "Unweighted" ? matchingRowCopy.answerUnweightedShare_Index : matchingRowCopy.answerWeightedShare_Index);
          if (ShareNumber == null) {
            matchingRowCopy.ColorCode = "black";
            return '0';
          }
          else {
            calculatedPercentage =
              matchingRowCopy.isDerived &&
                this.isIndex &&
                this.selectedIndex != ''
                ? Number((ShareNumber * 100).toFixed(1))
                : (matchingRowCopy.isDerived &&
                  matchingRowCopy.CalculationType == 'mean') ||
                  matchingRow.isCustomCalculation
                  ? Number(ShareNumber.toFixed(1))
                  : Number((ShareNumber * 100).toFixed(1));

            if (calculatedPercentage < (100 - this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "red";
            }
            else if (calculatedPercentage > (100 + this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "green";
            }
            else {
              matchingRowCopy.ColorCode = "black";
            }
          }
          this.crossTabReceivedData.forEach((row: any) => {
            if (
              row.CalculationType === matchingRowCopy.CalculationType &&
              row.Level1ColChild === matchingRowCopy.Level1ColChild &&
              row.Level1ColResponseCode === matchingRowCopy.Level1ColResponseCode &&
              row.Level1NestColVariableCode === matchingRowCopy.Level1NestColVariableCode &&
              row.Level1NestRowVariableCode === matchingRowCopy.Level1NestRowVariableCode &&
              row.Level1RowChild === matchingRowCopy.Level1RowChild &&
              row.Level1RowResponseCode === matchingRowCopy.Level1RowResponseCode &&
              row.Level2ColChild === matchingRowCopy.Level2ColChild &&
              row.Level2ColResponseCode === matchingRowCopy.Level2ColResponseCode &&
              row.Level2NestColVariableCode === matchingRowCopy.Level2NestColVariableCode &&
              row.Level2NestRowVariableCode === matchingRowCopy.Level2NestRowVariableCode &&
              row.Level2RowChild === matchingRowCopy.Level2RowChild &&
              row.Level2RowResponseCode === matchingRowCopy.Level2RowResponseCode &&
              row.colChild === matchingRowCopy.colChild &&
              row.colResponseCode === matchingRowCopy.colResponseCode &&
              row.colVariableCode === matchingRowCopy.colVariableCode &&
              row.rowChild === matchingRowCopy.rowChild &&
              row.rowResponseCode === matchingRowCopy.rowResponseCode &&
              row.rowVariableCode === matchingRowCopy.rowVariableCode
            ) {
              row.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare_Index;
              row.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare_Index;
              row.ColorCode = matchingRowCopy.ColorCode;
            }
          });

          if (typeof window !== 'undefined') {
            (window as any)['CrossTabData_Index'] = _.cloneDeep(this.crossTabReceivedData);
          }

          return this.calculatePercentage(matchingRowCopy);
        }
      }

      return this.calculatePercentage(matchingRow);
    }
  }


  getPercentage_multiLevel_rowLevel1_columnLevel2(
    rowLevel0: any,
    rowLevel1: any,
    colLevel0: any,
    colLevel1: any,
    colLevel2: any
  ): number | string {
    //Find the row that matches the response codes
    (window as any)['CrossTabData_Index'] = [];
    if (this.isTranspose) {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) =>
          row.isDerived && row.CalculationType.toLowerCase() == 'mean'
            ?
            row.colResponseCode == rowLevel0.responsecode &&
            row.colVariableCode == rowLevel0.variablecode &&
            row.rowVariableCode == colLevel0.variablecode &&
            row.rowResponseCode == colLevel0.responsecode &&
            row.Level1ColResponseCode == rowLevel1.responsecode &&
            row.Level1NestColVariableCode == rowLevel1.variablecode &&
            row.Level1RowResponseCode == colLevel1.responsecode &&
            row.Level1NestRowVariableCode == colLevel1.variablecode &&
            row.Level2RowResponseCode == colLevel2.responsecode &&
            row.Level2NestRowVariableCode == colLevel2.variablecode &&
            row.CalculationType.toLowerCase() == 'mean'
            : row.colResponseCode == rowLevel0.responsecode &&
            row.colVariableCode == rowLevel0.variablecode &&
            row.Level1ColResponseCode == rowLevel1.responsecode &&
            row.Level1NestColVariableCode == rowLevel1.variablecode &&
            row.rowVariableCode == colLevel0.variablecode &&
            row.rowResponseCode == colLevel0.responsecode &&
            row.Level1RowResponseCode == colLevel1.responsecode &&
            row.Level1NestRowVariableCode == colLevel1.variablecode &&
            row.Level2RowResponseCode == colLevel2.responsecode &&
            row.Level2NestRowVariableCode == colLevel2.variablecode
      );
      return this.calculatePercentage(matchingRow);
    } else {
      const matchingRow = this.crossTabReceivedData.find(
        (row: CrossTabOutputItem) =>
          row.isDerived && row.CalculationType.toLowerCase() == 'mean'
            ? row.rowResponseCode == rowLevel0.responsecode &&
            row.rowVariableCode == rowLevel0.variablecode &&
            row.colVariableCode == colLevel0.variablecode &&
            row.colResponseCode == colLevel0.responsecode &&
            row.Level1RowResponseCode == rowLevel1.responsecode &&
            row.Level1NestRowVariableCode == rowLevel1.variablecode &&
            row.Level1ColResponseCode == colLevel1.responsecode &&
            row.Level1NestColVariableCode == colLevel1.variablecode &&
            row.Level2ColResponseCode == colLevel2.responsecode &&
            row.Level2NestColVariableCode == colLevel2.variablecode &&
            row.CalculationType.toLowerCase() == 'mean' &&
            row.rowChild == rowLevel0.Child &&
            row.Level1RowChild == rowLevel1.Child &&
            row.colChild == colLevel0.Child &&
            row.Level1ColChild == colLevel1.Child &&
            row.Level2ColChild == colLevel2.Child
            : row.isCustomGroup
              ? row.rowResponseCode == rowLevel0.responsecode &&
              row.rowVariableCode == rowLevel0.variablecode &&
              row.colVariableCode == colLevel0.variablecode &&
              row.colResponseCode == colLevel0.responsecode &&
              row.Level1RowResponseCode == rowLevel1.responsecode &&
              row.Level1NestRowVariableCode == rowLevel1.variablecode &&
              row.Level1ColResponseCode == colLevel1.responsecode &&
              row.Level1NestColVariableCode == colLevel1.variablecode &&
              row.Level2ColResponseCode == colLevel2.responsecode &&
              row.Level2NestColVariableCode == colLevel2.variablecode &&
              row.isCustomGroup == true &&
              (row.customGroupId == rowLevel0.customGroupId ||
                row.customGroupId == colLevel2.customGroupId) &&
              row.rowChild == rowLevel0.Child &&
              row.Level1RowChild == rowLevel1.Child &&
              row.colChild == colLevel0.Child &&
              row.Level1ColChild == colLevel1.Child &&
              row.Level2ColChild == colLevel2.Child
              : row.isCustomCalculation
                ? row.rowResponseCode == rowLevel0.responsecode &&
                row.rowVariableCode == rowLevel0.variablecode &&
                row.colVariableCode == colLevel0.variablecode &&
                row.colResponseCode == colLevel0.responsecode &&
                row.Level1RowResponseCode == rowLevel1.responsecode &&
                row.Level1NestRowVariableCode == rowLevel1.variablecode &&
                row.Level1ColResponseCode == colLevel1.responsecode &&
                row.Level1NestColVariableCode == colLevel1.variablecode &&
                row.Level2ColResponseCode == colLevel2.responsecode &&
                row.Level2NestColVariableCode == colLevel2.variablecode &&
                row.isCustomCalculation == true &&
                (row.customCalculationId == rowLevel0.customCalculationId ||
                  row.customCalculationId == colLevel2.customCalculationId) &&
                row.rowChild == rowLevel0.Child &&
                row.Level1RowChild == rowLevel1.Child &&
                row.colChild == colLevel0.Child &&
                row.Level1ColChild == colLevel1.Child &&
                row.Level2ColChild == colLevel2.Child
                : row.rowResponseCode == rowLevel0.responsecode &&
                row.rowVariableCode == rowLevel0.variablecode &&
                row.Level1RowResponseCode == rowLevel1.responsecode &&
                row.Level1NestRowVariableCode == rowLevel1.variablecode &&
                row.colVariableCode == colLevel0.variablecode &&
                row.colResponseCode == colLevel0.responsecode &&
                row.Level1ColResponseCode == colLevel1.responsecode &&
                row.Level1NestColVariableCode == colLevel1.variablecode &&
                row.Level2ColResponseCode == colLevel2.responsecode &&
                row.Level2NestColVariableCode == colLevel2.variablecode &&
                row.rowChild == rowLevel0.Child &&
                row.Level1RowChild == rowLevel1.Child &&
                row.colChild == colLevel0.Child &&
                row.Level1ColChild == colLevel1.Child &&
                row.Level2ColChild == colLevel2.Child
      );

      if (this.isIndex && this.selectedIndex != "") {
        const matchingReferenceRow = this.crossTabReceivedData.find(
          (row: CrossTabOutputItem) =>
            row.isDerived && row.CalculationType.toLowerCase() == 'mean'
              ? row.rowResponseCode == rowLevel0.responsecode &&
              row.rowVariableCode == rowLevel0.variablecode &&
              row.colVariableCode == colLevel0.variablecode &&
              row.colResponseCode == colLevel0.responsecode &&
              row.Level1RowResponseCode == rowLevel1.responsecode &&
              row.Level1NestRowVariableCode == rowLevel1.variablecode &&
              row.Level1ColResponseCode == colLevel1.responsecode &&
              row.Level1NestColVariableCode == colLevel1.variablecode &&
              row.Level2ColChild == this.selectedIndex &&
              row.CalculationType.toLowerCase() == 'mean'
              : row.rowResponseCode == rowLevel0.responsecode &&
              row.rowVariableCode == rowLevel0.variablecode &&
              row.Level1RowResponseCode == rowLevel1.responsecode &&
              row.Level1NestRowVariableCode == rowLevel1.variablecode &&
              row.colVariableCode == colLevel0.variablecode &&
              row.colResponseCode == colLevel0.responsecode &&
              row.Level1ColResponseCode == colLevel1.responsecode &&
              row.Level1NestColVariableCode == colLevel1.variablecode &&
              row.Level2ColChild == this.selectedIndex
        );

        if (matchingReferenceRow != undefined) {
          const matchingRowCopy = { ...matchingRow };
          const matchingReferenceRowCopy = { ...matchingReferenceRow };

          if (this.selectedWeight == "Unweighted") {
            matchingRowCopy.totalUnweightedShare = isNaN(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? null : isFinite(matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) ? (matchingRowCopy.totalUnweightedShare / matchingReferenceRowCopy.totalUnweightedShare) : null;
            matchingRowCopy.answerUnweightedShare = isNaN(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? null : isFinite(matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) ? (matchingRowCopy.answerUnweightedShare / matchingReferenceRowCopy.answerUnweightedShare) : null;

            matchingRowCopy.totalUnweightedShare_Index = matchingRowCopy.totalUnweightedShare;
            matchingRowCopy.answerUnweightedShare_Index = matchingRowCopy.answerUnweightedShare;

          }
          else {
            matchingRowCopy.totalWeightedShare = isNaN(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? null : isFinite(matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) ? (matchingRowCopy.totalWeightedShare / matchingReferenceRowCopy.totalWeightedShare) : null;
            matchingRowCopy.answerWeightedShare = isNaN(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? null : isFinite(matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) ? (matchingRowCopy.answerWeightedShare / matchingReferenceRowCopy.answerWeightedShare) : null;

            matchingRowCopy.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare;
            matchingRowCopy.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare;
          }
          let calculatedPercentage: number;
          let ShareNumber = this.isTotalBase
            ? (this.selectedWeight == "Unweighted" ? matchingRowCopy.totalUnweightedShare_Index : matchingRowCopy.totalWeightedShare_Index)
            : (this.selectedWeight == "Unweighted" ? matchingRowCopy.answerUnweightedShare_Index : matchingRowCopy.answerWeightedShare_Index);
          if (ShareNumber == null) {
            matchingRowCopy.ColorCode = "black";
            return '0';
          }
          else {
            calculatedPercentage =
              matchingRowCopy.isDerived &&
                this.isIndex &&
                this.selectedIndex != ''
                ? Number((ShareNumber * 100).toFixed(1))
                : (matchingRowCopy.isDerived &&
                  matchingRowCopy.CalculationType == 'mean') ||
                  matchingRow.isCustomCalculation
                  ? Number(ShareNumber.toFixed(1))
                  : Number((ShareNumber * 100).toFixed(1));

            if (calculatedPercentage < (100 - this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "red";
            }
            else if (calculatedPercentage > (100 + this.ThresholdValue)) {
              matchingRowCopy.ColorCode = "green";
            }
            else {
              matchingRowCopy.ColorCode = "black";
            }
          }

          this.crossTabReceivedData.forEach((row: any) => {
            if (
              row.CalculationType === matchingRowCopy.CalculationType &&
              row.Level1ColChild === matchingRowCopy.Level1ColChild &&
              row.Level1ColResponseCode === matchingRowCopy.Level1ColResponseCode &&
              row.Level1NestColVariableCode === matchingRowCopy.Level1NestColVariableCode &&
              row.Level1NestRowVariableCode === matchingRowCopy.Level1NestRowVariableCode &&
              row.Level1RowChild === matchingRowCopy.Level1RowChild &&
              row.Level1RowResponseCode === matchingRowCopy.Level1RowResponseCode &&
              row.Level2ColChild === matchingRowCopy.Level2ColChild &&
              row.Level2ColResponseCode === matchingRowCopy.Level2ColResponseCode &&
              row.Level2NestColVariableCode === matchingRowCopy.Level2NestColVariableCode &&
              row.Level2NestRowVariableCode === matchingRowCopy.Level2NestRowVariableCode &&
              row.Level2RowChild === matchingRowCopy.Level2RowChild &&
              row.Level2RowResponseCode === matchingRowCopy.Level2RowResponseCode &&
              row.colChild === matchingRowCopy.colChild &&
              row.colResponseCode === matchingRowCopy.colResponseCode &&
              row.colVariableCode === matchingRowCopy.colVariableCode &&
              row.rowChild === matchingRowCopy.rowChild &&
              row.rowResponseCode === matchingRowCopy.rowResponseCode &&
              row.rowVariableCode === matchingRowCopy.rowVariableCode
            ) {
              row.totalWeightedShare_Index = matchingRowCopy.totalWeightedShare_Index;
              row.answerWeightedShare_Index = matchingRowCopy.answerWeightedShare_Index;
              row.ColorCode = matchingRowCopy.ColorCode;
            }
          });

          if (typeof window !== 'undefined') {
            (window as any)['CrossTabData_Index'] = _.cloneDeep(this.crossTabReceivedData);
          }

          return this.calculatePercentage(matchingRowCopy);
        }
      }
      return this.calculatePercentage(matchingRow);
    }
  }

  pairWiseText(pairWiseValues: PairWiseDetails[]) {
    let html = "";
    if (pairWiseValues != null && pairWiseValues.length > 0) {
      html = " | ";
      pairWiseValues.forEach((x: PairWiseDetails) => {
        html = ` ${html} <span class='${x.color}'>${x.pairWiseAlph}</span>`
      })
    }
    return html;
  }

  customRound(num: number): number {
    //if (num == -1.7041564866026857) {
    //  num = -1.7641564866026857;
    //  const roundedValue = Math.round(num * 10) / 10; // Round to one decimal place
    //  return roundedValue;
    //}
    //else {
    const roundedValue = Math.round(num * 10) / 10; // Round to one decimal place
    return roundedValue;
    // }
  }

  isColumnValid(colData: any) {
    if (this.TrendToggleOn == true || this.staticTimePeriod == true) {
      return true;
    }

    if (
      colData.Data[0].Child == this._configService.selectedTPforNonTrendView
    ) {
      return true;
    } else {
      return false;
    }
  }

  IsRowContainData(row:any){
    if(this.dropdownLevel1 == 1 ){
      let brand = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      let flag = false;
      if(row.NestedArray > 0){
        row.NestedArray.forEach( (item :any)=>{
          if(item.brand!=null && item.brand!=undefined &&
              item.brand.toLowerCase() == brand[0].name){
                flag = true;
              }
        })
      }
      return flag

    }else{
      let flag = false
      let metric = this.dropdownLevel2.filter((item:any)=> item.is_selected == true);
      if(row.NestedArray > 0){
        row.NestedArray.forEach( (item :any)=>{
          if(item.Child!=null && item.Child!=undefined &&
              item.Child.toLowerCase() == metric[0].name){
                flag = true;
              }
        })
      }
      return flag;
    }
    
  }
}
